<template>
  <div>
    <v-alert
      v-if="userDataLoaded && dossierPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van Dossier  is actief voor {{ activeCompData.name }}. </v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ dossierPackage.days }} <span style="color: #2196f3" v-if="dossierPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      top
      :timeout="snackbar.timeout"
      >
      <v-row>
        <v-icon color="white" class="mx-3">{{ snackbar.icon}}</v-icon>
        <span class="py-2 white--text">{{ snackbar.text}}</span>
      </v-row>
    </v-snackbar>

    
    <v-container v-if="caller || userDataLoaded" class="ma-0 mb-4 pa-0" style="max-width: 100%!important">
      <v-layout row wrap class="ma-0 pa-1">

        <v-flex v-if="caller" md9 xs12 ></v-flex>

        <v-flex v-if="!caller && !id && userCompanies.length > 1 && !demoMode" md3 xs12 >     
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadBranches()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details=""
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex v-if="!caller" :class="filterGridClass" xs12 sm6> 
          <v-select
            v-if="!caller && !id"
            class="ma-1"
            dense
            outlined
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            :items="branches"
            item-text="branchName"
            item-value="id"
            v-model="selectedBranch"
            v-on:input="loadselectedBranchData();"
            label="Vestiging"
            hide-details
          ></v-select>
        </v-flex>    
        <v-flex v-if="!caller" :class="filterGridClass" xs12 sm6>
          <v-menu
            v-if="!caller && !id"
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ma-1"
                dense
                outlined
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"    
                v-model="timeinfo"
                label="Datum"
                prepend-inner-icon="event"
                readonly
                hide-details
                v-on="on"
                ></v-text-field>
            </template>

            <v-date-picker
              v-model="chosenDateCalendar"
              no-title
              :color="companyPrimaryColor"
              :max="max"
              scrollable
              :first-day-of-week="1"
              v-on:input="loadDossierData(chosenDateCalendar)"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex :class="filterGridClass" xs12>
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex v-if="!caller && !id" md3 xs12 >
              <div class="ofText">of</div>
            </v-flex>

            <v-flex md9 xs12 style="position:relative;">
              <v-text-field
                class="ma-1"
                dense
                outlined
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"    
                style="width: 100%;"
                hide-details
                autocomplete="disabled"
                placeholder="naam/email/telefoon"
                label="Vind een klant"
                prepend-inner-icon="search"
                :append-inner-icon="loaderSearch ? 'fas fa-circle-notch fa-spin' : ''"
                v-model="zoekSalonhubClient"
                clearable
              ></v-text-field>
              

              <div v-if="zoekSalonhubClient && zoekSalonhubClient.length > 2" class="searchResults">
                <v-card
                  style="position: absolute; z-index:99; max-height: 260px; overflow-y: scroll; right: 0;"
                  class="mx-auto"
                  tile
                  >
                  <v-list v-for="(resultsSearch, index) in searchResultsSalonhub" :key="index"  two-line subtitle dense class="pa-0 ma-0">
                    <v-list-item @click="callerNotFound = false; selectClientRecipe(resultsSearch.id, 1); selectedClientId = resultsSearch.id; searchResultsSalonhub = [], zoekSalonhubClient = ''">
                      <v-list-item-avatar >
                        <v-icon class="my-0" style="background-color: #eee;">person</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ resultsSearch.firstname }} {{ resultsSearch.middlename }} {{ resultsSearch.lastname }}</v-list-item-title>
                        <v-list-item-subtitle>{{resultsSearch.address}} <span style="color: rgba(0,0,0,0.54);" v-if="resultsSearch.address">{{resultsSearch.number}}, </span>{{resultsSearch.city}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < searchResultsSalonhub.length"></v-divider> 
                  </v-list>

                </v-card>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        
      </v-layout>
    </v-container>

    <div v-if="dataloaded == false || userDataLoaded == false" class="blackbox-loader"></div>

    <div class="no-caller-data" v-if="dataloaded && callerNotFound && !loadingError">
      <v-card>
        <div class="hogans-modal-header" v-bind:style="{ backgroundColor: companyPrimaryColor}">
          <h2>Telefoonnummer onbekend: {{caller }}</h2>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <p>Dit telefoonnummer is niet bekend. Zoek de juiste of maak een <b>nieuwe klantenkaart</b> aan in Salonhub.</p><br>
          <p>Nieuwe kaarten worden dagelijks automatisch bijgewerkt.</p>
        </v-card-text>
      </v-card>
    </div>

    <div class="no-salon-data" v-if="dataloaded && noData && !loadingError">
      <p>Geen data gevonden. Selecteer een salon</p>
    </div>

    <div class="no-salon-data" v-if="dataloaded && !noData && loadingError">
      <v-layout justify-space-around>
        <v-icon large color="warning">warning</v-icon>
      </v-layout>
      <p style="padding: 10px">{{loadingError}}</p>
    </div>

    <div class="dossier-content" v-if="dataloaded && !noData && !loadingError">
      <v-container class="pa-0 ma-0" grid-list-sm style="max-width: 100%">

        <div v-if="wolfload" class="blackbox-loader"></div>

        <v-layout row wrap>
          <v-flex xs12 sm4 v-if="!caller && !id">
            <div class="client-select-box" >
              <v-tabs background-color="background" show-arrows>
                <v-tab @click="tab='2'" >Klanten</v-tab>
                <v-tab @click="tab='1'" >Recepten</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item value="1" :transition="tabTransition" :reverse-transition="tabTransition">
                  <v-card outlined :max-height="windowDossierHeight"  style="overflow-y: scroll;" class="no-scroll">
                    <span v-if="recipesFiltered.length == 0">
                      <p class="no-clients">Geen klanten met recepten</p>
                    </span>
                    <span v-else>
                      <v-list v-for="(recipe, index) in recipesFiltered" :key="index"  two-line subtitle  class="pa-0 ma-0">
                        <v-list-item @click="selectClientRecipe(recipe.customerId, 0); selectedClientId = recipe.customerId; namecustomer = recipe.customerName; ConvertEmployeeRecipe(recipe.employeeId);">
                          <v-list-item-avatar >
                            <v-img
                              class="my-0"
                              v-if="recipe.thumbUrl"
                              :src="recipe.thumbUrl"
                            ></v-img>
                            <v-icon
                              style="background-color: #f9f9f9;"
                              class="my-0"
                              v-else
                              color="#8b93a6"
                              dark
                            >
                              person
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ recipe.customerName }}</v-list-item-title>
                            <!-- <v-list-item-subtitle>
                              <span v-if="recipe.description">{{ recipe.description }}</span>
                            </v-list-item-subtitle> -->
                            <v-list-item-subtitle class="list-extra-info">{{ recipe.startHour }}:{{recipe.startMinute}}u {{recipe.employeeName}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon>
                            <span v-if="recipe.latestJourneyScore">
                              <v-icon
                                v-if="recipe.latestJourneyScore > 3"
                                color="#25142A"
                              >star</v-icon>
                              <v-icon
                                v-if="recipe.latestJourneyScore == 2 || recipe.latestJourneyScore == 3"
                                color="#25142A"
                              >star_half</v-icon>
                              <v-icon
                                v-if="recipe.latestJourneyScore == 1"
                                color="#25142A"
                              >star_border</v-icon>
                            </span>
                            <v-icon
                              v-if="recipe.completed == true"
                              color="green accent-2"
                            >check_circle</v-icon>
        
                            <v-icon v-if="recipe.customerId == 0" color="red">warning</v-icon>  
                          </v-list-item-icon>
                        </v-list-item>
                        <v-divider v-if="index + 1 < recipesFiltered.length"></v-divider> 
                      </v-list>
                    </span>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="2" :transition="tabTransition" :reverse-transition="tabTransition">
                  <v-card outlined :max-height="windowDossierHeight"  style="overflow-y: scroll;" class="no-scroll"> 
                    <span v-if="appointmentsFiltered.length == 0">
                      <p class="no-clients">Geen klanten</p>
                    </span>
                    <span v-else>
                      <v-list v-for="(clientsitem, index) in appointmentsFiltered" :key="index"  two-line subtitle  class="pa-0 ma-0">
                        <v-list-item  @click="selectClientRecipe(clientsitem.customer, 1); selectedClientId = clientsitem.customer; namecustomer = clientsitem.customerName; ConvertEmployeeAllclients(clientsitem.employee);">
                          <v-list-item-avatar >
                            <v-img
                              class="my-0"
                              v-if="clientsitem.thumbUrl"
                              :src="clientsitem.thumbUrl"
                            ></v-img>
                            <v-icon
                              style="background-color: #f9f9f9;"
                              class="my-0"
                              v-else
                              color="#8b93a6"
                              dark
                            >
                              person
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ clientsitem.customerName }}</v-list-item-title>
                            <!-- <v-list-item-subtitle>
                              <span v-if="clientsitem.description">{{ clientsitem.description }}</span>
                            </v-list-item-subtitle> -->
                            <v-list-item-subtitle class="list-extra-info">{{ clientsitem.startHour }}:{{clientsitem.startMinute}}u {{clientsitem.employeeName}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <span v-if="clientsitem.latestJourneyScore && (userRole != 'employee' || (userRole == 'employee' && !userPermissions.hideCustomerReviews))">
                              <v-icon
                                v-if="clientsitem.latestJourneyScore > 3"
                                color="#25142A"
                              >star</v-icon>
                              <v-icon
                                v-if="clientsitem.latestJourneyScore == 2 || clientsitem.latestJourneyScore == 3"
                                color="#25142A"
                              >star_half</v-icon>
                              <v-icon
                                v-if="clientsitem.latestJourneyScore == 1"
                                color="#25142A"
                              >star_border</v-icon>
                            </span>
                            <v-icon
                              v-if="clientsitem.completed == true"
                              color="green accent-2"
                            >check_circle</v-icon>
        
                            <v-icon v-if="clientsitem.customerId == 0" color="red">warning</v-icon>  
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider v-if="index + 1 < appointmentsFiltered.length"></v-divider> 
                      </v-list>
                  
                    </span>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>

              

            </div>
            <div v-if="selectedTab == 'recepten' && recipesFiltered.length > 0" style="padding: 15px; text-align: center;">
              <span v-if="recipesFiltered.length > 1">{{ recipesFiltered.length }} recepten</span>
              <span v-if="recipesFiltered.length == 1">{{ recipesFiltered.length }} recept</span>
            </div>
            <div v-if="selectedTab == 'klanten' && appointmentsFiltered.length > 0" style="padding: 15px; text-align: center;">
              <span v-if="appointmentsFiltered.length > 1">{{ appointmentsFiltered.length }} klanten</span>
              <span v-if="appointmentsFiltered.length == 1">{{ appointmentsFiltered.length }} klant</span> 
            </div>
          </v-flex>

          <v-flex column :class="clientColumn">       
            <div class="client-info-wrapper pr-5 no-scroll" :style="{maxHeight: windowDossierClientHeight}"  style="overflow-y: scroll;">
              <div v-if="Object.keys(chosenCustomerrecipe).length !== 0">
                
                <!-- Header info -->
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs8>
                      <h2>{{chosenCustomerrecipe.firstname}} {{chosenCustomerrecipe.middlename}} {{chosenCustomerrecipe.lastname}}</h2>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn
                        style="float: right"
                        v-if="!caller && (companyDossierPhotos == true || userRole == 'superadmin')"
                        fab
                        dark
                        :color="companyPrimaryColor"
                        @click="createClientPhoto()"
                        >
                        <v-icon>camera_alt</v-icon>
                      </v-btn>
                
                      <div class="client-header-button" v-if="caller && selectedCustomerSurveys.length > 0 && latestSurveyScoresLowest && (userRole != 'employee' || (userRole == 'employee' && !userPermissions.hideCustomerReviews))">
                        <v-tooltip class="ma-0 pa-0" left >
                          <template v-slot:activator="{ on }">
                            <a class="dossier-client-lowest-score" :class="'rating-number-' + latestSurveyScoresLowest" dark v-on="on"></a>
                          </template>
                          <span style="color: #fff;">Laagste beoordeling van laatste bezoek</span>
                        </v-tooltip>
                      </div>
                  
                      <div class="client-header-button" v-if="caller || id">
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn fab darken :color="companyPrimaryColor" @click="addNewClientQueue()">
                              <v-icon v-on="on" color="#fff">queue</v-icon>
                            </v-btn>
                          </template>
                          <span style="color: #fff;">Voeg cli&euml;nt toe aan wachtlijst.</span>
                        </v-tooltip>
                      </div>
                    </v-flex> 
                  </v-layout>
                </v-container> 
                
                <v-alert style="margin-top: 15px;" class="pa-2" value="true" v-if="clientQueue.length > 0 " type="info" icon-color="#fff">
                  <span style="color: #fff;">{{ clientQueue.length }} cli&euml;nt<span v-if="clientQueue.length > 1" style="color: #fff;">en</span> in de wachtrij. <router-link tag="a" style="color: #fff;" :to="`/clientqueue`">Bekijk de wachtlijst</router-link >.</span>
                </v-alert>

                <!-- Algemene informatie klant -->
                <v-card outlined class="mt-2" width="100%">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12></v-flex>
                      <v-flex xs5>
                        <div
                          class="client-email clear"
                          v-if="chosenCustomerInfo.email !== '' "
                          >
                          <v-icon class="pillar-grey">email</v-icon>
                          <p>{{ chosenCustomerInfo.email }}</p>
                        </div>

                        <div class="client-email clear" v-else>
                          <v-icon>email</v-icon>
                          <v-icon color="red">warning</v-icon>
                          <p :style="{color: companyPrimaryColor}">Geen email aanwezig</p>
                        </div>
                    
                        <div
                          class="client-birtday clear"
                        >
                          <v-icon class="pillar-grey">cake</v-icon>
                          <p v-if="chosenCustomerInfo.birthday !== '0000-00-00' ">{{ chosenCustomerInfo.birthday | moment("D MMM YYYY") }}</p>
                          <span v-else>
                            <v-icon color="red" style="margin: 5px 0 5px 5px;" small>warning</v-icon>
                            <p>Verjaardag ontbreekt, vul dit aan via Salonhub!</p>
                          </span>
                        </div>

                        <div class="client-birtday clear">
                          <v-icon class="pillar-grey">mdi-identifier</v-icon>
                          <p>{{ selectedClientId }}</p>
                        </div>

                        
                      </v-flex>

                      <v-flex xs7>
                        <div class="client-visits clear"
                          v-if="chosenCustomerInfo.numberOfVisits !== null || chosenCustomerInfo.numberOfVisits !== '' "
                        >
                          <v-icon class="pillar-grey">person</v-icon>
                          <p>Aantal bezoeken: {{ chosenCustomerInfo.numberOfVisits }}</p>
                        </div>
                        <div
                          class="client-last-visit clear"
                          v-if="chosenCustomerInfo.weeksAgo !== null || chosenCustomerInfo.weeksAgo !== '' "
                        >
                          <v-icon class="pillar-grey">event_available</v-icon>
                          <p>Laatste bezoek {{Number(chosenCustomerInfo.lastVisit) | moment("D MMMM YYYY")}}, {{ chosenCustomerInfo.weeksAgo}} weken</p>
                        </div>
                      </v-flex>
                      <v-flex xs12 v-if="activeCompData.id != 'beautybyroos'">
                        <!-- Feedback blurren om de klant niet te confronteren met ongepaste tekst-->
                        <div
                          class="client-notes"
                          @touchstart="notesActive = true"
                          @mousedown="notesActive = true"
                          @mouseup="notesActive = false"
                          @touchend="notesActive = false"
                          v-if="chosenCustomerInfo.information !== '' && !caller && !userPermissions.hideCustomerInfo"
                          >
                          <v-icon class="pillar-grey">notes</v-icon>
                          <p v-bind:class="{ active: notesActive }">
                            <strong>Salonhub notities:</strong>
                            {{chosenCustomerInfo.information}}
                          </p>
                        </div>

                        <div class="client-notes" v-if="chosenCustomerInfo.information == '' && !caller && !userPermissions.hideCustomerInfo">
                          <v-icon class="pillar-grey">notes</v-icon>
                          <p class="active">Geen Salonhub notities aanwezig</p>
                        </div>

                        <!-- Feedback niet blurren als er gebeld wordt.-->
                        <div
                          class="client-notes"
                          v-if="chosenCustomerInfo.information !== '' && caller"
                        >
                          <v-icon class="pillar-grey">notes</v-icon>
                          <p v-bind:class="{ active: notesActive }">
                            <strong>Salonhub notities:</strong>
                            {{chosenCustomerInfo.information}}
                          </p>
                        </div>

                        <div class="client-notes" v-if="chosenCustomerInfo.information == '' && caller">
                          <v-icon class="pillar-grey">notes</v-icon>
                          <p class="active">Geen Salonhub notities aanwezig</p>
                        </div>
                      </v-flex>
                    </v-layout>

                    <!-- <v-layout row wrap v-if="!userPermissions.hideCustomerInfo" > -->
                    <v-layout row wrap v-if="activeCompData.id != 'beautybyroos'">
                      <v-flex xs6>
                        <h3>Aandachtspunten</h3>
                        <div v-for="(attention, index) in clientAttentions" :key="index" class="attention-wrapper clear">
                          <div class="attention-icon">
                              <v-icon v-if="attention.type == 'do'" color="#00E676" style="margin: 5px 5px 0 0;">add_circle</v-icon> 
                              <v-icon v-else color="#EF5350" style="margin: 5px 5px 0 0; float:left;">remove_circle</v-icon>
                          </div>

                          <div class="attention-text">
                            <p style="margin: 8px 5px 0 0;" :style="{color: $vuetify.theme.themes[theme].text}">{{ attention.text }}</p>
                          </div>
                          <div class="attention-remove" @click="removeClientAttention(attention.id, index)">
                            <v-btn class="ma-0" icon color="#cacdd2">
                              <v-icon color="#cacdd2">delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        
                        <div style="margin: 5px;" class="text-xs-center">
                          <p v-if="clientAttentions.length == 0" style="padding: 5px;" :style="{color: $vuetify.theme.themes[theme].text}">Er zijn nog geen aandachtspunten voor {{chosenCustomerrecipe.firstname}} toegevoegd. </p>
                          <div class="text-center">
                            <v-tooltip class="ma-0 pa-0" bottom >
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="clientAttentionDialog.show = true" fab dark small :color="companyPrimaryColor"><v-icon dark>add</v-icon></v-btn>
                              </template>
                              <span style="color: #fff;">Nieuw aandachtspunt toevoegen</span>
                            </v-tooltip>
                          </div>
                        </div>

                      </v-flex>
                      <v-flex xs6>
                        <h3>Notities</h3>
                        <div v-for="(note, index) in clientNotes" :key="index" class="note-wrapper clear">
                          <div class="note-date">
                            <div class="note-date-cal-wrap" :style="{'backgroundColor': '#cacdd2'}">
                              <div class="note-date-cal-day">{{note.dateAdded.seconds | moment("D")}}</div>
                            <div class="note-date-cal-month">{{note.dateAdded.seconds | moment("MMM")}}</div>
                            </div>
                          </div>
                          <div class="note-text">
                            <p :style="{color: $vuetify.theme.themes[theme].text}">{{ note.text }}</p>
                          </div>
                          <div class="note-remove" @click="removeClientNote(note.id, index)">
                            <v-btn icon color="#cacdd2">
                              <v-icon color="#cacdd2">delete</v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <div style="margin: 5px;" class="text-xs-center">
                          <p v-if="clientNotes.length == 0" style="padding: 5px;" :style="{color: $vuetify.theme.themes[theme].text}" >Er zijn nog geen notities voor {{chosenCustomerrecipe.firstname}} toegevoegd. </p>
                          <div class="text-center">
                            <v-tooltip class="ma-0 pa-0" bottom >
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="clientNoteDialog.show = true" fab dark small :color="companyPrimaryColor"><v-icon dark>add</v-icon></v-btn>
                              </template>
                              <span style="color: #fff;">Nieuwe notitie toevoegen</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>

                    <div v-if="activeCompData.id == 'hairbeautycompany' || (activeCompData.id == 'hairbeautycompany' && userRole == 'superadmin')">
                      <h3>Social koppelingen</h3>
                      <v-layout row wrap class="mt-4">
                        <v-flex xs6>
                          <v-list-item @click="clientSocialDialog.show = true">
                            <v-badge
                              overlap
                              color="#69F0AE"
                              icon="check"
                              class="ma-2"
                              v-if="clientSocial.piggy && clientSocial.piggy.email"
                              >
                              <v-avatar
                                color="#f9f9f9"
                                >
                                <v-img
                                  class="my-0"
                                  src="../assets/social-icons/piggy-logo.png" 
                                ></v-img>
                              </v-avatar>
                            </v-badge>
                            <v-list-item-avatar color="#f9f9f9" v-else>
                              <v-img
                                class="my-0"
                                src="../assets/social-icons/piggy-logo.png" 
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title style="font-size: 14px;" :style="{color: $vuetify.theme.themes[theme].text}" v-if="clientSocial.piggy && clientSocial.piggy.email">{{ clientSocial.piggy.email }} </v-list-item-title>
                              <v-list-item-title style="font-size: 14px;" :style="{color: $vuetify.theme.themes[theme].text}" v-else>Piggy Points niet gekoppeld</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-flex>
                        <v-flex xs6>
                          <v-list-item @click="clientSocialDialog.show = true">
                            <v-badge
                              v-if="clientSocial.instagram"
                              overlap
                              color="#69F0AE"
                              icon="check"
                              >
                              <v-avatar color="#f9f9f9">
                                <v-img
                                  class="my-0"
                                  src="../assets/social-icons/instagram-logo.png" 
                                ></v-img>
                              </v-avatar>
                            </v-badge>
                            <v-list-item-avatar color="#f9f9f9" v-else>
                              <v-img
                                class="my-0"
                                src="../assets/social-icons/instagram-logo.png"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title style="font-size: 14px;" :style="{color: $vuetify.theme.themes[theme].text}" v-if="clientSocial.instagram">{{ clientSocial.instagram }} </v-list-item-title>
                              <v-list-item-title style="font-size: 14px;" :style="{color: $vuetify.theme.themes[theme].text}" v-else>Instagram niet gekoppeld</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                        </v-flex>
                        <v-flex xs12>
                          <v-card outlined color="#FC5200" v-if="!piggyPointsLoading">
                            <v-card-text>
                              <v-layout row wrap class="ma-0 pa-0">
                                <v-flex xs12 class="py-1">
                                  <p v-if="clientPiggyPoints =='notfound'" class="white--text ma-0 pa-0 text-center" style="font-size:16px">Het gekoppelde account kan niet gevonden worden bij Piggy. Mogelijk klopt het e-mailadres niet.</p>
                                  <p v-else-if="!clientPiggyPoints" class="white--text ma-0 pa-0 text-center" style="font-size:16px"> Er is nog geen Piggy account gekoppeld. Koppel het account om de punten te bekijken.</p>
                                  <p v-else class="white--text ma-0 pa-0 text-center" style="font-size:16px"> {{chosenCustomerrecipe.firstname}} heeft <strong>{{ clientPiggyPoints }}</strong> Piggy-punten te besteden bij {{ activeCompData.name }}.</p>
                                </v-flex>
                              </v-layout>
                            </v-card-text>

                            

                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card-text>
                </v-card>
    
                <!-- Foto's -->
                <div class="mt-4">
                  <h2>Foto's</h2>                        
                  <v-card outlined width="100%">
                    <v-container class="ma-0" grid-list-sm v-if="Object.keys(lastclientPhotos).length !== 0">
                      <v-layout
                        row
                        wrap
                        @click="comparePhotos()"
                        >
                        <v-flex xs3>
                          <v-img
                            v-if="lastclientPhotos.photoCollection.front_thumb"
                            :src="lastclientPhotos.photoCollection.front_thumb"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </v-img>
                        </v-flex>

                        <v-flex xs3>
                          <v-img
                            v-if="lastclientPhotos.photoCollection.side_thumb"
                            :src="lastclientPhotos.photoCollection.side_thumb"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </v-img>
                        </v-flex>

                        <v-flex xs3>
                          <v-img
                            v-if="lastclientPhotos.photoCollection.back_thumb"
                            :src="lastclientPhotos.photoCollection.back_thumb"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </v-img>
                        </v-flex>

                        <v-flex xs3>
                          <v-img
                            v-if="lastclientPhotos.photoCollection.extra_thumb"
                            :src="lastclientPhotos.photoCollection.extra_thumb"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </v-img>
                        </v-flex>
                        <v-flex xs12>
                          <p class="ma-0" style="color: #8b93a6">{{ lastclientPhotos.datePhoto | moment("D MMMM YYYY") }}</p>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-card-text v-else>
                      <p style="margin: 0; text-align: center;" >Geen foto's beschikbaar.</p>
                    </v-card-text>
                  </v-card>                           
                </div>

                 <!-- Haarconditie Medische intake -->
                 <div v-if="activeCompData.id == 'beautybyroos' && dataloaded" class="mt-4">
                  <h2>Haarconditie</h2>
                  <v-card outlined width="100%" :key="medicalIntakesChanges">
                    <div v-if="chosenCustomerInfo.medicalIntakes && chosenCustomerInfo.medicalIntakes.length > 0">
                      <v-data-table
                        :headers="headersMedicalIntakes"
                        :items="chosenCustomerInfo.medicalIntakes"
                        :options="tableOptionsDeviatingAdvices"
                        hide-default-footer
                        show-expand
                        single-expand
                        :key="chosenCustomerInfo.medicalIntakes.length + medicalIntakesChanges"
                        >
                        <template v-slot:item="{item, isExpanded, expand}">
                          <tr>
                            <td class="text-xs-left">{{ item.dateAdded.seconds | moment("D-MM-YYYY - H:mm") }}u</td>
                            <td class="text-xs-left"><v-btn @click="viewMedicalIntake(item)" fab small depressed :color="companyPrimaryColor" dark><v-icon>mdi-format-list-checkbox</v-icon></v-btn></td>
                            <td>
                              <v-tooltip v-if="!isExpanded" bottom>
                                <template v-slot:activator="{on}">
                                  <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                                </template>
                                <span style="color: #fff;">Meer informatie tonen</span>
                              </v-tooltip>

                              <v-tooltip v-if="isExpanded" bottom>
                                <template v-slot:activator="{on}">
                                  <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                                </template>
                                <span style="color: #fff;">Meer informatie verbergen</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length" style="padding: 0;">
                            <v-card flat>
                              <v-card-text>

                                <v-layout row wrap>
                                  <v-flex xs12>
                                      <b>Feedback:</b><br>
                                      <h2>Uitkomst vragenlijst</h2>
                                      <div v-if="item.feedback.questions.length > 0">
                                        <div v-for="(feedback, index) in item.feedback.questions" :key="index" class="py-2">
                                            <span v-html="feedback"></span>
                                        </div>
                                      </div>
                                      <div v-if="item.feedback.questions.length== 0" class="py-2">
                                        <p>Je hebt geen extra risico op haaruitval of afbrekend haar. </p>
                                      </div>

                                      <h2>Uitkomst Analyse</h2>
                                      <div v-if="item.feedback.analyse.length > 0">
                                        <div v-for="(feedback, index) in item.feedback.analyse" :key="index" class="py-2 feedback">
                                            <span v-html="feedback"></span>
                                        </div>
                                      </div>
                                      <div v-if="item.feedback.analyse.length == 0" class="py-2">
                                        <p>Geen extra bijzonderheden</p>
                                      </div>

                                    </v-flex>
                                  <v-flex xs4>
                                    <b>Handtekening:</b><br>
                                    <v-img width="250px" :src="item.clientSignature"></v-img>
                                  </v-flex>
                                </v-layout>
                  
                              </v-card-text>
                            </v-card>
                          </td>
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </div>
                    <div v-else class="text-center pa-4">
                      Er is nog geen haarconditie bepaald.
                    </div>
                    <div class="text-center pa-4">
                      <v-btn :color="companyPrimaryColor" dark @click="newClientMedicalIntake()">Haarconditie bepalen</v-btn> 
                    </div>
                  </v-card>
                </div>

                <!-- Afwijkend advies -->
                <div v-if="activeCompData.id == 'beautybyroos' && dataloaded" class="mt-4">
                  <h2>Toestemmingsformulieren afwijkende adviezen</h2>
                  <v-card outlined width="100%">
                    <div v-if="chosenCustomerInfo.deviatingAdvices && chosenCustomerInfo.deviatingAdvices.length > 0">
                      <v-data-table
                        :headers="headersDeviatingAdvices"
                        :items="chosenCustomerInfo.deviatingAdvices"
                        :options="tableOptionsDeviatingAdvices"
                        hide-default-footer
                        :key="chosenCustomerInfo.deviatingAdvices.length"
                        >
                        <template v-slot:item="{item}">
                          <tr @click="viewDeviatingAdvice(item)">
                            <td class="text-xs-left">{{ item.timestamp | moment("D-MM-YYYY - H:mm") }}u</td>
                            <td class="text-right">
                              <v-btn icon small><v-icon>mdi-chevron-right</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </div>
                    <div v-else class="text-center pa-4">
                      Er zijn nog geen toestemmingsformulieren.
                    </div>
                    <div class="text-center pa-4">
                      <v-btn :color="companyPrimaryColor" dark @click="newClientDeviatingAdvice()">Nieuw toestemmingsformulier</v-btn> 
                    </div>
                  </v-card>
                </div>

                <!-- Abonnement formulieren -->
                <div v-if="activeCompData.id == 'beautybyroos' && dataloaded" class="mt-4">
                  <h2>Abonnement formulieren</h2>
                  <v-card outlined width="100%" :key="membershipChanges">
                    <div v-if="chosenCustomerInfo.memberships && chosenCustomerInfo.memberships.length > 0">
                      <v-data-table
                        :headers="membershipHeaders"
                        :items="chosenCustomerInfo.memberships"
                        :options="tableOptionsDeviatingAdvices"
                        show-expand
                        single-expand
                        hide-default-footer
                        :key="chosenCustomerInfo.memberships.length + membershipChanges"
                        >
                        <template v-slot:item="{item, isExpanded, expand}">
                          <tr>
                            <td>{{ item.dateAddedFormatted }}u</td>
                            <td>{{ getMembershipType(item.type) }}</td>
                            <td>{{ getBranchName(item.branch) }}</td>
                            <td>&euro; {{ item.amount }}</td>
                            <td>
                              <v-tooltip v-if="!isExpanded" bottom>
                                <template v-slot:activator="{on}">
                                  <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                                </template>
                                <span style="color: #fff;">Meer informatie tonen</span>
                              </v-tooltip>

                              <v-tooltip v-if="isExpanded" bottom>
                                <template v-slot:activator="{on}">
                                  <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                                </template>
                                <span style="color: #fff;">Meer informatie verbergen</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length" style="padding: 0;">
                            <v-card flat>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                    <b>Extra informatie:</b><br>
                                    {{ item.street }} {{ item.number }}<br>
                                    {{ item.zipcode }} {{ item.city }}<br><br>
                                    <div v-if="item.iban">
                                      <b>IBAN:</b><br>
                                      {{ item.iban }} <br><br>
                                    </div>
                                  </v-flex>
                                  <v-flex xs4>
                                    <b>Paspoort/ID:</b><br>
                                    <v-img width="250px" :src="item.clientIdUrl"></v-img>
                                  </v-flex>
                                  <v-flex xs4>
                                    <b>Bankpas:</b><br>
                                    <v-img width="250px" :src="item.clientCardUrl"></v-img>
                                  </v-flex>
                                  <v-flex xs4>
                                    <b>Handtekening:</b><br>
                                    <v-img width="250px" :src="item.clientSignature"></v-img>
                                  </v-flex>
                                </v-layout>  
                              </v-card-text>
                            </v-card>
                          </td>
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </div>
                    <div v-else class="text-center pa-4">
                      Er zijn nog geen abonnement formulieren.
                    </div>
                    <div class="text-center pa-4">
                      <v-btn :color="companyPrimaryColor" dark @click="newClientMembership()">Nieuw abonnement formulier</v-btn> 
                    </div>
                  </v-card>
                </div>

                 <!-- Klachten -->
                 <div v-if="activeCompData.id == 'beautybyroos' && dataloaded" class="mt-4">
                  <h2>Klachten</h2>
                  <v-card outlined width="100%" :key="complainsChanges">
                    <div v-if="chosenCustomerInfo.complains && chosenCustomerInfo.complains.length > 0">
                      <v-data-table
                        :headers="headerscomplains"
                        :items="chosenCustomerInfo.complains"
                        :options="tableOptionsDeviatingAdvices"
                        hide-default-footer
                        :key="chosenCustomerInfo.complains.length + complainsChanges"
                        >
                        <template v-slot:item="{item}">
                          <tr>
                            <td class="text-xs-left">{{ item.date | moment("DD-MM-YYYY") }}</td>
                            <td class="text-xs-left">{{ getBranchName(item.branch)}}</td>
                            <td class="text-xs-left"> <v-chip small v-for="(complain,i) in item.complain" :key="i" class="mr-1 mb-1">{{ getComplainName(complain) }}</v-chip> </td>
                            <td class="text-right">
                              <v-btn icon small @click="viewComplain(item)"><v-icon>mdi-eye</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
              
                      </v-data-table>
                      <v-divider></v-divider>
                    </div>
                    <div v-else class="text-center pa-4">
                      Er zijn nog geen klachten.
                    </div>
                    <div class="text-center pa-4">
                      <v-btn :color="companyPrimaryColor" dark @click="addNewComplain()">Klacht toevoegen</v-btn> 
                    </div>
                  </v-card>
                </div>

                <!-- Behandelingen geschiedenis -->
                <div v-if="chosenCustomerInfo.treatments != 0 && !userPermissions.hideCustomerInfo" class="mt-4">
                  <h2>Behandelingen geschiedenis</h2>
                  <v-card outlined width="100%">
                    <v-data-table
                      :headers="headerstreatments"
                      :items="chosenCustomerInfo.treatments"
                      :options="tableOptions"
                    >
                      <template v-slot:item="{item}">
                        <tr :key="Math.random(484864886)">
                          <td
                            class="text-xs-left"
                          >{{ item.timestamp | moment("D-MM-YYYY") }}</td>
                          <td>{{ item.employeeName }}</td>
                          <td>
                            <span
                              v-if="item.description"
                            >{{ item.description }}</span>
                          </td>
                          <td>€ {{ item.amount }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>

                <!-- Nieuwste Recept -->
                <div class="mt-4" v-if="chosenCustomerrecipe.coloring != 0 && !userPermissions.hideCustomerInfo">
                  <h2>Nieuwste recept</h2>
                  <v-card outlined width="100%">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs8>
                          <div class="recipe-info pt-2 clear" v-if="chosenCustomerrecipeNewest.description">
                            <v-icon class="pillar-grey">event_note</v-icon>
                            <p class="ma-0">{{chosenCustomerrecipeNewest.description}}</p>
                          </div>
                          <div class="recipe-date pt-2 clear" v-if="chosenCustomerrecipeNewest !== null">
                            <v-icon class="pillar-grey">event_available</v-icon>
                            <p class="ma-0">Bijgewerkt op {{chosenCustomerrecipeNewest.date | moment("dddd D MMMM YYYY")}}</p>
                          </div>
                          <div class="recipe-time pt-2 clear" v-if="chosenCustomerrecipeNewest.length !== '' ">
                            <v-icon class="pillar-grey">timer</v-icon>
                            <p class="ma-0">Inwerktijd {{chosenCustomerrecipeNewest.length}}</p>
                          </div>
                          <div class="recipe-time pt-2 clear" v-else>
                            <v-icon class="pillar-grey">timer</v-icon>
                            <v-icon color="red" small style="margin: 5px 0 5px 5px;">warning</v-icon>
                            <p>Inwerktijd ontbreekt, vul dit aan via Salonhub!</p>
                          </div>
                          <div class="recipe-person pt-2 clear" v-if="chosenCustomerrecipeNewest.employeeName !== null">
                            <v-icon class="pillar-grey">person</v-icon>
                            <p class="ma-0">Medewerker {{chosenCustomerrecipeNewest.employeeName}}</p>
                          </div>
                          <div class="recipe-person pt-2 clear" v-else>
                            <v-icon class="pillar-grey">person</v-icon>
                            <v-icon color="red" small style="margin: 5px 0 5px 5px;">warning</v-icon>
                            <p class="ma-0"
                              :style="{color: companyPrimaryColor}"
                            >Medewerker recept ontbreekt, aanvullen in Salonhub!</p>
                          </div>
                        </v-flex>

                        <v-flex xs4>
                          <div v-if="employeephoto" class="recipe-employee-photo-wrapper">
                            <div class="recipe-employee-photo">
                              <v-img
                                
                                :src="employeephoto"
                                aspect-ratio="1"
                                class="grey lighten-4"
                              >
                            
                              </v-img>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </div>
                
                <!-- Recepten geschiedenis -->
                <div v-if="chosenCustomerrecipe.coloring != 0 && !userPermissions.hideCustomerInfo" class="mt-4">
                  <h2>Recepten geschiedenis</h2>
                  <v-card outlined width="100%">
                    <v-data-table
                      :headers="headers"
                      :items="chosenCustomerrecipe.coloring"
                      :options="tableOptions"
                      >
                      <template v-slot:item="{item}">
                        <tr>
                          <td>{{ item.date | moment("D-MM-YYYY") }}</td>
                          <td
                            v-if="item.employeeName !== null"
                          >{{ item.employeeName }}</td>
                          <td class="text-xs-left" v-else>
                            <v-icon small color="red">warning</v-icon>
                          </td>
                          <td>
                            <span v-if="item.description">{{ item.description }}</span>
                          </td>
                          <td v-if="item.length.length !== 0 ">{{ item.length }}</td>
                          <td class="text-xs-left" v-else>
                            <v-icon small color="red">warning</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              
                <!-- Producten geschiedenis -->
                <div v-if="chosenCustomerrecipe.products != 0 && !userPermissions.hideCustomerInfo" class="mt-4">
                  <h2>Producten geschiedenis</h2>
                  <v-card outlined width="100%">
                    <v-data-table
                      :headers="headersproducts"
                      :items="chosenCustomerInfo.products"
                      :options="tableOptions"
                      class="dossier-table"
                      >
                      <template v-slot:item="{item}">
                        <tr :key="Math.random(484864886)">
                          <td
                            class="text-xs-left"
                          >{{ item.timestamp | moment("D-MM-YYYY") }}</td>
                          <td>{{ item.employeeName }}</td>
                          <td>
                            <span
                              v-if="item.description"
                            >{{ item.description }}</span>
                          </td>
                          <td>€ {{ item.amount }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>

                <!-- Journey Resultaten -->
                <div id="surveys" class="my-4" v-if="selectedCustomerSurveys.length > 0 && (userRole != 'employee' || (userRole == 'employee' && !userPermissions.hideCustomerReviews))">
                  <h2>Reviews</h2>
                  <v-card outlined width="100%">
                    <div class="client-datatable header dossier clear">
                      <div class="col-one"></div>
                      <div class="col-two">Datum verzonden</div>
                      <div class="col-three">Beantwoord</div>
                      <div class="col-four">Score</div>
                      <div class="col-five">Salon</div>
                      <div class="col-six">Geholpen door</div>
                      <div class="col-seven"></div>
                    </div>

                    <div v-for="survey in selectedCustomerSurveys" :key="survey.id">
                      <div class="client-datatable custom-row clear">
                        <div class="col-one">
                          <v-icon color="#78909C" v-if="survey.expanded == false" @click="closeSurveyData(survey), loadSurveyData(survey)">arrow_right</v-icon>
                          <v-icon color="#78909C" v-if="survey.expanded == true"  @click="survey.expanded = false,loadSurveyData(survey)"> arrow_drop_down</v-icon>
                          </div>
                        <div class="col-two">{{ survey.dateSend.seconds | moment("D MMMM YYYY") }}</div>
                        <div class="col-three">
                          <span v-if="survey.ratingSummary">
                            {{ survey.ratingSummary.length }} / {{ survey.ratingItems }}
                          </span>
                          <span v-else>
                            0 / {{ survey.ratingItems }}
                          </span>
                        </div>
                        <div class="col-four">
                          <span v-if="survey.ratingSummary.length > 0">
                            <span class="client-data-smiley block" v-bind:class="'score-' + Math.round(survey.ratingSummary.reduce((a, b) => a + b, 0) / survey.ratingSummary.length)"></span>
                            <span class="client-data-score">{{ ((survey.ratingSummary.reduce((a, b) => a + b, 0) / survey.ratingSummary.length)*2).toFixed(1) }}</span>
                          </span>
                        </div>
                        <div class="col-four">
                          <span v-for="branch in branches" :key="branch.id">
                            <span v-if="branch.id == survey.branchId">{{ branch.branchName}}</span>
                          </span>
                        </div>
                        <div class="col-six">
                          <span>{{ survey.clientLastTreatmentByName }}</span>
                        </div>
                        <div class="col-sven text-right">
                          <v-icon small class="mx-1" color="text" v-if="survey.manualCompanyAnswered">headset_mic</v-icon>
                          <v-btn v-if="userRole == 'admin' || userRole == 'superadmin' " @click="editSurveyData(survey.id)" text icon>
                            <v-icon small class="mx-1" color="text" >edit</v-icon>
                          </v-btn>
                        </div>

                      </div>

                      <div v-if="survey.expanded == true">
                        <div class="client-datatable dossier expanded-row clear" v-for="(surveyQuestion, index) in surveyQuestions" :key="index">
                          <div class="col-one"> </div>
                          <div class="col-two">{{ surveyQuestion.question[survey.clientLanguage]}}</div>
                          <div class="col-three">
                            <span class="client-data-no-result" v-if="surveyQuestion.type == 'rating' && !surveyQuestion.rating">Geen beoordeling</span>
                            <span class="client-data-no-result" v-if="surveyQuestion.type == 'feedback' && !surveyQuestion.feedback">Geen feedback</span>
                            <span v-if="surveyQuestion.feedback">{{surveyQuestion.feedback }}</span>
                            <span v-if="surveyQuestion.rating">
                              <div class="client-data-smiley block" v-bind:class="'score-' + surveyQuestion.rating"></div>
                              <div class="client-data-score" v-if="surveyQuestion.rating" >{{ (surveyQuestion.rating * 2).toFixed(1)}}</div>
                            </span>
                          </div>
                          <div class="col-four">
                            <span v-if="surveyQuestion.dateUpdated">{{ surveyQuestion.dateUpdated.seconds | moment("D MMM YYYY - H:mm") }}u</span>
                          </div>

                          <div class="col-five"></div>
                          <div class="col-six"></div>
                          <div class="col-seven"></div>
                        </div>
                      </div>
                    </div>
                    <!-- <v-data-table
                      :headers="headerstreatments"
                      :items="chosenCustomerInfo.treatments"
                      :pagination.sync="pagination2"
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="Math.random(484864886)">
                          <td
                            class="text-xs-left"
                          >{{ item.timestamp | moment("D-MM-YYYY") }}</td>
                          <td>{{ item.employeeName }}</td>
                          <td>
                            <span
                              v-if="item.description"
                            >{{ item.description }}</span>
                          </td>
                          <td>€ {{ item.amount }}</td>
                        </tr>
                      </template>
                    </v-data-table> -->
                  </v-card>
                </div>
              </div>
            </div>
          </v-flex>
          <!-- Eerste flexbox -->
        </v-layout>

        <!-- Geen klantenkaart -->
        <v-dialog v-model="noclientdialog" persistent max-width="390">
          <v-card width="100%">
            <v-card-text style="text-align: center;">
              <div class="connection-popup-wrapper">
                <div class="popup-icon">
                  <v-icon x-large color="red">warning</v-icon>
                </div>
              </div>
              <h2 class="popup-title">Klantenkaart ontbreekt!</h2>
              <v-spacer></v-spacer>
              <p
                class="lost-connection-text"
              >Ook nieuwe of onbekende klanten zoals "{{namecustomer}}" hebben een klantenkaart nodig. Ga naar Salonhub om de gegevens juist in te voeren.</p>
            </v-card-text>
            <v-card-actions>
              <v-layout align-center>
                <v-flex xs12 text-xs-center style="padding: 0 0 10px 0;">
                  <v-btn
                    :color="companyPrimaryColor"
                    round
                    dark
                    @click="noclientdialog = false"
                  >Ok, begrepen</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Geen recept -->
        <v-dialog v-model="norecipedialog" scrollable persistent max-width="390">
          <v-card width="100%"> 
            <v-card-title class="headline">Geen recept voor {{namecustomer}} aanwezig</v-card-title>
            <v-divider></v-divider>
            <v-card-text>Er is nog niet eerder een recept voor {{namecustomer}} klant aangemaakt. Ga naar Salonhub om een nieuw recept toe te voegen.</v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="align-center">
              <v-btn
                :color="companyPrimaryColor"
                rounded
                dark
                @click="norecipedialog = false"
              >Ok, begrepen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Client Social Dialog -->
        <v-dialog v-model="clientSocialDialog.show" max-width="600">
          <v-card width="100%">

            <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
              <h2 style="color:white">Social koppelingen aanpassen</h2>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="clientSocialDialog.show = false">
                <v-icon dark color="white">close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="hogans-alerts">
              <v-alert
                v-if="clientSocialDialog.feedback"
                :value="true"
                type="warning"
              >
              {{ clientSocialDialog.feedback }} 
              </v-alert>
            </div>

            <v-divider></v-divider>
              
            <v-card-text>
              <v-text-field
                label="Piggy e-mailadres "
                v-model="clientSocialDialog.piggy.email"
                hint="E-mailadres dat de cliënt gebruikt voor zijn Piggy Account"
                :rules="emailRules"
                persistent-hint
                required
              ></v-text-field>

                <v-text-field
                :rules="instaRules"
                label="Instagram gebruikersnaam"
                v-model="clientSocialDialog.instagram"
                hint="Gebruikersnaam die de cliënt gebruikt voor zijn Instagram Account"
                persistent-hint
                required
              ></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-container grid-list-md fluid class="ma-0 pa-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                    <v-btn
                      outlined
                      depressed
                      color="#8B93A6"
                      @click="clientSocialDialog.show = false"
                      >
                      Annuleren
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn
                      
                      rounded
                      :dark="!socialDisable" 
                      :disabled="socialDisable" 
                      :depressed="socialDisable"  
                      :color="companySecondaryColor"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      @click="addClientSocial()"
                      >
                      Opslaan
                      <v-icon right dark>chevron_right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>

          </v-card>
        </v-dialog>

        <!-- Add Client Afwijkend Advies Dialog (BEAUTY BY ROOS) -->
        <v-dialog v-model="deviatingAdvice.dialog" max-width="700" scrollable>
          <v-card width="100%">
            <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
              <h2 v-if="deviatingAdvice.type == 'new'" style="color:white">Toestemmingsformulieren toevoegen</h2>
              <h2 v-else style="color:white">Toestemmingsformulieren van {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</h2>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="removeClientDeviatingAdvice(deviatingAdvice.id)" v-if="deviatingAdvice.type == 'view' && (userRole == 'admin' ||  userRole == 'superadmin' )" >
                <v-icon dark color="white">mdi-delete</v-icon>
              </v-btn>

              
              <v-btn icon dark @click="closeDeviatingAdviceDialog()" :disabled="deviatingAdvice.uploading">
                <v-icon dark color="white">close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="hogans-alerts">
              <v-alert
                v-if="deviatingAdvice.feedback"
                :value="true"
                type="warning"
                style="border-radius: 0!important"
                v-html="deviatingAdvice.feedback"
              ></v-alert>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pt-2">

              <p class="pt-4 mb-0">Beauty by Roos Hairextensions voert uitsluitend behandelingen uit op advies van alle Hairextensions Professionals die werkzaam zijn bij Beauty by Roos Hairextensions. Wanneer de klant een afwijkende behandeling wil bij ons in de salon is dit volledig op eigen risico en vervalt de garantie op de uitgevoerde behandeling.</p>

              <v-card color="menu" flat outlined class="pa-0">
                <h4 v-if="deviatingAdvice.type == 'new'" style="font-size: 18px; font-weight: bold" class="py-4">Selecteer afwijkende wensen van de klant</h4>
                <h4 v-else style="font-size: 18px; font-weight: bold" class="py-4">Afwijkende wensen van de klant</h4>
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="deviatingAdvice.deviatings"
                  value="differentLength"
                  label="Andere lengte gewenst dan geadviseerd"
                  :disabled="deviatingAdvice.type == 'view'"
                ></v-checkbox>
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="deviatingAdvice.deviatings"
                  value="differentColor"
                  label="Andere kleur gewenst dan geadviseerd"
                  :disabled="deviatingAdvice.type == 'view'"
                ></v-checkbox>
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="deviatingAdvice.deviatings"
                  value="differentBrand"
                  label="Ander merk extensions gewenst dan geadviseerd"
                  :disabled="deviatingAdvice.type == 'view'"
                ></v-checkbox>
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="deviatingAdvice.deviatings"
                  value="differentNumber"
                  label="Ander aantal extensions gewenst dan geadviseerd"

                  :disabled="deviatingAdvice.type == 'view'"
                ></v-checkbox>
              </v-card>

              <v-card color="background" flat outlined class="pa-3 my-4">
                <h4 style="font-size: 18px; font-weight: bold">Geadviseerd</h4>

                <v-container grid-list-md class="ma-0 pa-0" >
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs6>
                      <v-text-field
                        class="mt-3"
                        label="Lengte"
                        v-model="deviatingAdvice.advice.length"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Kleur"
                        v-model.trim="deviatingAdvice.advice.color"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                      </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Merk"
                        v-model="deviatingAdvice.advice.brand"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Aantal"
                        v-model="deviatingAdvice.advice.number"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                        class="mt-3"
                        label="Aanvullende opmerkingen"
                        v-model="deviatingAdvice.advice.notes"
                        required
                        outlined
                        rows="3"
                        hide-details
                        background-color="menu"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>  
              </v-card>

              <v-card color="background" flat outlined class="pa-3 my-4">
                <h4 style="font-size: 18px; font-weight: bold" >Gekozen door de klant</h4>
                <v-container grid-list-md class="ma-0 pa-0" >
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs6>
                      <v-text-field
                        class="mt-3"
                        label="Lengte"
                        v-model="deviatingAdvice.clientChoice.length"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Kleur"
                        v-model="deviatingAdvice.clientChoice.color"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                      </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Merk"
                        v-model="deviatingAdvice.clientChoice.brand"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Aantal"
                        v-model="deviatingAdvice.clientChoice.number"
                        required
                        dense
                        outlined
                        background-color="menu"
                        hide-details
                        class="mt-3"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        class="mt-3"
                        label="Aanvullende opmerkingen"
                        v-model="deviatingAdvice.clientChoice.notes"
                        required
                        outlined
                        hide-details
                        rows="3"
                        background-color="menu"
                        :readonly="deviatingAdvice.type == 'view'"
                        :disabled="deviatingAdvice.type == 'view'"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container> 
              </v-card>

              <v-container grid-list-md class="ma-0 mt-4 pa-0 pt-4" >
                <h4 style="font-size: 18px; font-weight: bold" >Naam en handtekening voor akkoord</h4>

                <p class="ma-0 pb-0 pt-2" v-if="deviatingAdvice.type == 'new'">Middels deze ondertekening geef ik Beauty by Roos Hairextensions toestemming om een behandeling uit te voeren die niet overeenkomt met het gegeven advies door de Hairextensions Professional van Beauty by Roos Hairextensions. Ik verklaar hierbij ook dat ik geen negatieve reviews over Beauty by Roos zal plaatsen.</p>
                <p class="ma-0 pb-0 pt-2" v-else>Middels deze ondertekening heb ik Beauty by Roos Hairextensions toestemming gegeven om een behandeling uit te voeren die niet overeenkomt met het gegeven advies door de Hairextensions Professional van Beauty by Roos Hairextensions. Ik verklaar hierbij ook dat ik geen negatieve reviews over Beauty by Roos zal plaatsen.</p>

                <div style="padding: 10px 0 0 0;">
                  <p v-if="deviatingAdvice.type == 'new'" style="font-size: 14px;"><strong>Datum:</strong> {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</p>
                </div>
                  
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs6>
                    <v-text-field
                      label="Naam"
                      :readonly="deviatingAdvice.type == 'view'"
                      :disabled="deviatingAdvice.type == 'view'"
                      v-model.trim="deviatingAdvice.clientName"
                      required
                      outlined
                      background-color="background"
                      dense
                    ></v-text-field>
                    <p class="pa-0 mb-1" style="font-size: 16px;"><strong>Handtekening</strong></p>
                    <div v-if="deviatingAdvice.type == 'new'">
                      <vueSignature ref="signature" :sigOption="signatureOptions" :w="'100%'" :h="'140px'" style="border: 2px solid #333; border-radius: 8px; overflow: hidden"></vueSignature> 
                      <v-btn small depressed class="my-2" @click="clearSignature">Wissen</v-btn>
                    </div>
                    <div v-else>
                      <v-img
                        max-width="350"
                        :src="deviatingAdvice.clientSignature"
                      ></v-img>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container> 
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-container grid-list-md fluid class="ma-0 pa-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                    <v-btn
                      outlined
                      depressed
                      :disabled="deviatingAdvice.uploading"
                      color="#8B93A6"
                      @click="closeDeviatingAdviceDialog()"
                      >
                      Annuleren
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn
                      v-if="deviatingAdvice.type == 'new'" 
                      rounded
                      :loading="deviatingAdvice.uploading"
                      :disabled="deviatingAdvice.uploading"
                      :dark="!deviatingAdvice.uploading"
                      :color="companySecondaryColor"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      @click="addClientDeviatingAdvice()"
                      >
                      Toevoegen
                      <v-icon right dark>chevron_right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>

          </v-card>
        </v-dialog>


        <!-- Add Client Attention Dialog -->
        <v-dialog v-model="clientAttentionDialog.show" max-width="600">
          <v-card width="100%">
            <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
              <h2 style="color:white">Aandachtspunt toevoegen</h2>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="clientAttentionDialog.show = false">
                <v-icon dark color="white">close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="hogans-alerts">
              <v-alert
                v-if="clientAttentionDialog.feedback"
                :value="true"
                type="warning"
              >
              {{ clientAttentionDialog.feedback }} 
              </v-alert>
            </div>

            <v-divider></v-divider>
              
            <v-card-text class="pt-2">
              <v-select
                v-model="clientAttentionDialog.type" 
                :items="clientAttentionTypes"
                hint="Moet het aandachtspunt juist WEL of NIET gedaan worden"
                item-text="name"
                item-value="id"
                label="Type "
                persistent-hint
                :prepend-icon="clientAttentionIcon"
              ></v-select>

              <v-text-field
                label="Aandachtspunt"
                v-model.trim="clientAttentionDialog.text"
                prepend-icon="feedback"
                required
              ></v-text-field>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-container grid-list-md fluid class="ma-0 pa-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                    <v-btn
                      outlined
                      depressed
                      color="#8B93A6"
                      @click="clientAttentionDialog.show = false"
                      >
                      Annuleren
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn
                      rounded
                      dark
                      :color="companySecondaryColor"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      @click="addClientAttention()"
                      >
                      Opslaan
                      <v-icon right dark>chevron_right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>

          </v-card>
        </v-dialog>

        <!-- Add Client Note Dialog -->
        <v-dialog v-model="clientNoteDialog.show" max-width="600">
          <v-card width="100%">
            <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
              <h2 style="color:white">Notitie toevoegen</h2>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="clientNoteDialog.show = false">
                <v-icon dark color="white">close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="hogans-alerts">
              <v-alert
                v-if="clientNoteDialog.feedback"
                :value="true"
                type="warning"
              >
              {{ clientNoteDialog.feedback }} 
              </v-alert>
            </div>

              <v-divider></v-divider>
              
            <v-card-text class="pt-2">

              <v-alert
                class="pa-2"
                style="margin: 0 0 5px 0"
                :value="true"
                type="info"
              >
                <span style="color: white;">Let op! Klanten kunnen via het dossier gemaakte notities bekijken. Schrijf daarom netjes en duidelijk.</span>
              </v-alert>
              
              <v-textarea
                label="Notitie"
                v-model.trim="clientNoteDialog.text"
                prepend-icon="feedback"
                no-resize
              ></v-textarea>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-container grid-list-md fluid class="ma-0 pa-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                    <v-btn
                      outlined
                      depressed
                      color="#8B93A6"
                      @click="clientNoteDialog.show = false"
                      >
                      Annuleren
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn
                      rounded
                      dark
                      :color="companySecondaryColor"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      @click="addClientNote()"
                      >
                      Toevoegen
                      <v-icon right dark>chevron_right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>

          </v-card>
        </v-dialog>

      </v-container>
    </div>

    <!-- / New ClientQueue Dialog \ -->
    <v-dialog v-model="newQueueDialog" scrollable max-width="600px">
      <add-client-to-queue :branches="branches" @newQueueDialogChange="newQueueDialog = $event"></add-client-to-queue>
    </v-dialog>
    <!-- \ New ClientQueue Dialog / -->

    <!-- / Create Photo Dialog \ -->

      <app-create-photo
        ref="createPhotoFunc"
        :chosenCustomerInfo="chosenCustomerInfo"
        :activeComp="activeComp"
        :activeCompData="activeCompData"
        :selectedBranch="selectedBranch"
        :selectedBranchData="selectedBranchData"
        :namecustomer="namecustomer"
        :chosencustomer="chosenCustomerInfo"
        :employees="salonhub.data.employees"
        :chosenEmployee="chosenEmployeeId"
        @createPhotoChange="photoModal = $event"
        @updateClient="showSnackbar('succes')"
      ></app-create-photo>

    <!-- \ Create Photo Dialog / -->

    <!-- / Compare Photo Dialog \ -->
    <app-compare-photo
      ref="comparePhotoFunc"
      :chosenCustomerInfo="chosenCustomerInfo"
      :activeComp="activeComp"
      @comparePhotoChange="comparephotoModal = $event"
    ></app-compare-photo>
    <!-- \ Compare Photo Dialog / -->

    <!-- / Edit Survey Data \ -->
    <edit-survey-data
      :activeCompData="activeCompData"
      :type="'dossier'"
      ></edit-survey-data>
    <!-- \ Edit Survey Data / -->

     <!-- / New Membership Dialog \ -->
      <add-membership-form :activeCompData="activeCompData" @updateData="loadCustomerMemberships"></add-membership-form>
    <!-- \ New Membership Dialog / -->

    <!-- / Medical Intake Dialog \ -->
    <add-medical-intake-form :activeCompData="activeCompData" @updateData="updateMedicalIntakeData()"></add-medical-intake-form>
    <!-- \ Medical Intake Dialog / -->

    <!-- / Complain Dialog \ -->
    <complain-form :activeCompData="activeCompData" :branches="branches" @updateData="updateComplainData()"></complain-form>
    <!-- \ Complain  Dialog / -->


  </div>
</template>
<script>
import db from "../firebase/init";
import firebase from "firebase/app";;
import lodash from "lodash";
import axios from "axios";
import { bus } from "../main";
import moment from "moment";
import router from "../router.js";
import "moment/locale/nl";

import platform from 'platform'; 
import slugify from "slugify";
import AddClientToQueue from "../components/modals/AddClientToQueue.vue";
import EditClientToQueue from "../components/modals/EditClientToQueue.vue";
import modalWithTreatment from "../components/modals/modalWithTreatment.vue";
import modalProduct from "../components/modals/modalProduct.vue";
import createPhoto from "../components/modals/createPhoto.vue";
import comparePhoto from "../components/modals/comparePhoto.vue";
import EditSurveyData from "../components/modals/EditSurveyData.vue";
import vueSignature from "vue-signature"
import AddMembershipForm from "../components/modals/AddMembership.vue";
import AddMedicalIntakeForm from "../components/modals/AddMedicalIntakeForm.vue";
import ComplainForm from "../components/modals/AddComplainForm.vue";


export default {
  icons: {
    iconfont: "fa"
  },
  components: {
  "add-client-to-queue": AddClientToQueue,
    "app-create-photo": createPhoto,
    "app-compare-photo": comparePhoto,
    "edit-survey-data": EditSurveyData,
    "add-membership-form": AddMembershipForm,
    "add-medical-intake-form": AddMedicalIntakeForm,
    "complain-form": ComplainForm,
    vueSignature
  },
  props: ["caller", "id"],
  name: "dossier",
  data() {
    return {
      membershipChanges: 0,
      medicalIntakesChanges: 0,
      complainsChanges: 0,
      selectedClientId: null,
      windowDossierHeight: 0,
      windowDossierClientHeight: 0,
      notesActive: false,
      chosenCustomerRecipe: null,
      chosenDateCalendar: moment().format("YYYY-MM-DD"),
      menu: false,
      max: moment()
        .add(1, "w")
        .format("YYYY-MM-DD"), //Calendar max x weken na voren
      chosenEmployeeId: null,
      noData: true,
      userDataLoaded: false,
      menuExpand: false,
      companies: [],
      branches: [],
      dataloaded: false,
      selectedBranch: null,
      selectedBranchData: [],
      barometersReady: true,
      activeComp: null,
      activeCompData: {},
      lastclientPhotos: {},
      loadingError: null,
      photoModal: false,
      clientPiggyPoints: null,
      piggyPointsLoading: true,
      comparephotoModal: false,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      instaRules: [
        v => !!v || "Instagram gebruikersnaamis verplicht",
        v => !/[~!#$@%\^&*+=\-\[\]\\;,/{}|\\":<>\?]/.test(v) || "Instagram gebruikersnaam invoeren."
      ],
      headerscomplains: [
        { text: "Datum", value: "timestamp", sortable: true, align: "left", width: "180px" },
        { text: "Vestiging", value: "branch", sortable: false, width: "150px"  },
        { text: "Klacht(en)", value: "complain", sortable: false },
        { text: "", value: "edit", sortable: false, width: "80px" }
      ],
      complainOptions: [
        {
          id: "itch",
          name: "Jeuk"
        },
        {
          id: "wrongPlacement",
          name: "Verkeerde plaatsing"
        },
        {
          id: "qualityHair",
          name: "Kwaliteit haar"
        },
        {
          id: "tangles",
          name: "Klitten"
        },
        {
          id: "tuftLoss",
          name: "Plukverlies"
        },
        {
          id: "cut",
          name: "Snijden"
        },
        {
          id: "visibility",
          name: "Zichtbaarheid"
        },
        {
          id: "discoloration",
          name: "Verkleuring"
        },
        {
          id: "Other",
          name: "Overig"
        },
      ],

      clientNoteDialog: {
        show:false,
        feedback: null,
        text: "",
        busy: false
      },
      deviatingAdvice: {
        type: null,
        dialog: false,
        feedback: null,
        deviatings: new Array(),
        advice: {
          length: null,
          color: null,
          brand: null,
          number: null,
          notes: null
        },
        clientChoice: {
          length: null,
          color: null,
          brand: null,
          number: null,
          notes: null
        },
        timestamp: null,
        clientName: null,
        uploading: false,
        clientSignature: null,
      },
      signatureOptions: {
        backgroundColor: 'white',
      },
      clientSocial: {},
      tabTransition: false,
      tab: "2",
      clientSocialDialog: {
        show:false,
        feedback: null,
        piggy: {
          email:null
        },
        instagram: "",
        piggyOriginal: null,
        instagramOriginal: "",
        busy: false,
        success: null,
      },
      clientAttentionDialog: {
        show:false,
        feedback: null,
        type: "do",
        text: "",
        busy: false
      },
      clientAttentionTypes: [
        {
          name: 'Doen',
          id: "do"
        },
        {
          name: 'Niet doen',
          id: "dont"
        }
      ],
      snackbar: {
        active: false,
        text: "",
        icon: "",
        timeout: -1,
        color: "",
      },
      searchCompanies:"",
      clientNotes: [],
      clientAttentions: [],
      wolfload: false,
      salonhubsettings: false,
      company: ["Hair & Beauty Company", "http://www.hairbeautycompany.nl"],
      salonhub: {
        data: {
          employees: [{ id: 1, name: "empty" }]
        }
      },
      selected: [2],
      tableOptions: {
        itemsPerPage: 10,
        // sortBy: 'date',
        sortDesc: true
      },
      tableOptionsDeviatingAdvices: {
        itemsPerPage: 100,
        // sortBy: 'date',
        sortDesc: true
      },
      timeinfo: null,
      recipes: [],
      clients: [],
      resourcesbooking: {}, // Personeel
      clientswithbooking: [], //Samen geperste data
      chosenCustomerrecipe: {},
      chosenCustomerrecipeNewest: {},
      chosenCustomerInfo: {},
      headers: [
        { text: "Datum", value: "date", sortable: true, align: "start", width: "180px" },
        { text: "Medewerker", value: "name", sortable: false },
        { text: "Recept", value: "description", sortable: false },
        { text: "Inwerktijd", value: "length", sortable: false }
      ],
      headersproducts: [
        { text: "Datum", value: "date", sortable: true, align: "start", width: "180px" },
        { text: "Medewerker", value: "name", sortable: false },
        { text: "Product", value: "description", sortable: false },
        { text: "Prijs", value: "amount", sortable: false }
      ],
      headerstreatments: [
        { text: "Datum", value: "date", sortable: true, align: "start", width: "180px" },
        { text: "Medewerker", value: "name", sortable: false },
        { text: "Behandeling", value: "description", sortable: false },
        { text: "Prijs", value: "amount", sortable: false }
      ],
      headersDeviatingAdvices: [
        { text: "Datum", value: "timestamp", sortable: true, align: "left", width: "180px" },
        { text: "", value: "edit", sortable: false }
      ],
      headersMedicalIntakes: [
        { text: "Datum", value: "timestamp", sortable: true, align: "left" },
        {
          text: "",
          value: "edit",
          align: "right",
          width: "50px",
          sortable: false
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "50px",
          sortable: false
        },
      ],
      membershipHeaders: [
        {
          text: "Datum",
          align: "left",
          value: "dateAdded",
          width: "200px"
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          width: "100px"
        },
        {
          text: "Vestiging",
          align: "left",
          value: "branch"
        },
        {
          text: "Bedrag",
          align: "left",
          value: "firstName"
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "50px",
          sortable: false
        },
      ],
      membershipTypes: [
        {
          id: "new",
          name: 'Nieuw (3 maanden)'
        },
        {
          id: "extension",
          name: 'Verlenging (3 maanden)'
        },
        {
          id: "newFour",
          name: 'Nieuw (4 maanden)'
        },
        {
          id: "extensionFour",
          name: 'Verlenging (4 maanden)'
        }
      ],
      employeephoto: "",
      resourcesbooking: {},
      clientThumbs: [],
      noclientdialog: false,
      norecipedialog: false,
      namecustomer: "",
      callersname: "Inkomend gesprek...",
      callerNotFound : false,
      selectedCustomerSurveys: [],
      latestSurveyScoresLowest: null,
      surveyQuestions: null,
      newQueueDialog: null,
      selectedTab: "recepten",
      clientQueue: [],
      selectedBranches: [],
      searchResultsSalonhub: [],
      zoekSalonhubClient: "",
      loaderSearch: false
    };
  },

  created() {
    let vm = this;
    this.calculateWindowHeigth()
    window.addEventListener('resize', function() {
      vm.calculateWindowHeigth()
    });
    this.loadUserComp();
    bus.$on("surveyEditDialogDossierChange", survey => {
      this.loadJourneyDataCustomer()
    });
  },

  methods: {

    clearSignature(){
      this.$refs.signature.clear();
    },

    viewMedicalIntake(item){
      console.log("item.salonhubId: ", item.salonhubId)
      let clientAppointment = this.appointmentsFiltered.find(client => { return Number(client.customer) == item.salonhubId } )
      let firstDate = moment().subtract(1, 'day').format("YYYY-MM-DD")
      let lastDate = moment().add(1, 'day').format("YYYY-MM-DD")

      console.log("clientAppointment: ", clientAppointment)
      console.log("firstDate: ", firstDate)
      console.log("lastDate: ", lastDate)


      if((this.userRole == 'admin' || this.userRole == 'superadmin' || this.userRole == 'manager')|| (clientAppointment && this.chosenDateCalendar >= firstDate && this.chosenDateCalendar <= lastDate)){
        bus.$emit("openMedicalIntakeDialog" , null, 'view', item);
      }
      else{
        this.snackbar.active = true;
        this.snackbar.timeout = 3000;
        this.snackbar.color = "rgba(183, 28, 28, 0.7)";
        this.snackbar.icon = "mdi-close-octagon";
        this.snackbar.text = "Je hebt nu geen toestemming om deze gegevens te bekijken.";
      }
      
    },

    newClientMedicalIntake(){
      bus.$emit("openMedicalIntakeDialog" , this.chosenCustomerInfo, 'add');
    },

    updateMedicalIntakeData(){
      this.chosenCustomerInfo.medicalIntakes = new Array();
      chosenCustomerInfo
        .where("companyId", "==", this.activeComp)
        .where("salonhubId", "==", Number(this.chosenCustomerInfo.id))
        .orderBy("dateAdded", "desc")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            this.chosenCustomerInfo.medicalIntakes.push(item);
          });
        })
        .then(()=>{
          this.medicalIntakesChanges++
        })
    },

    updateComplainData(){
      this.chosenCustomerInfo.complains = new Array();
      db.collection("complains")
        .where("companyId", "==", this.activeComp)
        .where("salonhubId", "==", Number(this.chosenCustomerInfo.id))
        .orderBy("date", "desc")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            this.chosenCustomerInfo.complains.push(item);
          });
        })
        .then(()=>{
          this.complainsChanges++
        })
    },

    viewDeviatingAdvice(item){
      this.deviatingAdvice.type = "view";
      this.deviatingAdvice.timestamp = item.timestamp;
      this.deviatingAdvice.deviatings = item.deviatings;
      this.deviatingAdvice.clientChoice = item.clientChoice
      this.deviatingAdvice.advice = item.advice;
      this.deviatingAdvice.id = item.id;
      this.deviatingAdvice.clientName = item.clientName;
      this.deviatingAdvice.clientSignature = item.clientSignature
      this.deviatingAdvice.dialog = true;
    },

    closeDeviatingAdviceDialog(){
      this.deviatingAdvice.dialog = false;
      if(this.deviatingAdvice.type == "new"){ // Alleen wissen als handtekening pad getoond wordt.
        this.clearSignature();
      }
      this.deviatingAdvice.type = "new";
      this.deviatingAdvice.deviatings = new Array();
      this.deviatingAdvice.advice.length = null;
      this.deviatingAdvice.advice.color = null;
      this.deviatingAdvice.advice.brand = null;
      this.deviatingAdvice.advice.number = null;
      this.deviatingAdvice.advice.notes = null;
      this.deviatingAdvice.clientChoice.length = null;
      this.deviatingAdvice.clientChoice.color = null;
      this.deviatingAdvice.clientChoice.brand = null;
      this.deviatingAdvice.clientChoice.number = null;
      this.deviatingAdvice.clientChoice.notes = null;
      this.deviatingAdvice.clientName = null;
      this.deviatingAdvice.id = null;
      this.deviatingAdvice.uploading = false;
      this.deviatingAdvice.feedback = null;
      
    },

    getMembershipType(type){
      let typeName = '';
      this.membershipTypes.forEach(element => {
        if(element.id == type){
          typeName = element.name
        }
      });
      return typeName;
    },   

    getBranchName(branche){
      let name = '';
      this.branches.forEach(element => {
        if(element.id == branche){
          name = element.branchName
        }
      });
      return name;
    },  

    viewComplain(item){
      bus.$emit("openComplainDialog" , null, 'view', item);
    },

    addNewComplain(){
      bus.$emit("openComplainDialog", this.chosenCustomerInfo, "add", null);
    },

    getBranchName(branch){
      let name = null;
      this.branches.forEach(option=>{
        if(option.id == branch){
          name = option.branchName;
        }
      })
      return name;
    },
    
    getComplainName(complain){
      let name = null;
      this.complainOptions.forEach(option=>{
        if(option.id == complain){
          name = option.name;
        }
      })
      return name;
    },
         
    addClientDeviatingAdvice(){
      this.deviatingAdvice.feedback = null;
      // this.deviatingAdvice.dialog = false;

      let length = (this.deviatingAdvice.deviatings.includes("differentLength") == true && this.deviatingAdvice.advice.length && this.deviatingAdvice.clientChoice.length) || this.deviatingAdvice.deviatings.includes("differentLength") == false ? true : false; 
      let color = (this.deviatingAdvice.deviatings.includes("differentColor") == true && this.deviatingAdvice.advice.color && this.deviatingAdvice.clientChoice.color) || this.deviatingAdvice.deviatings.includes("differentColor") == false ? true : false; 
      let brand = (this.deviatingAdvice.deviatings.includes("differentBrand") == true && this.deviatingAdvice.advice.brand && this.deviatingAdvice.clientChoice.brand) || this.deviatingAdvice.deviatings.includes("differentBrand") == false ? true : false; 
      let number = (this.deviatingAdvice.deviatings.includes("differentNumber") == true && this.deviatingAdvice.advice.number && this.deviatingAdvice.clientChoice.number) || this.deviatingAdvice.deviatings.includes("differentNumber") == false ? true : false; 
      
      if(this.deviatingAdvice.deviatings.length > 0){
        if(length && color && brand && number){
          if(!this.$refs.signature.isEmpty() && this.deviatingAdvice.clientName){
            this.deviatingAdvice.clientSignature = this.$refs.signature.save();
            console.log("this.deviatingAdvice.clientSignature: ", this.deviatingAdvice.clientSignature);

            const fileUrl = this.activeCompData.id + "/" + "sign/" + this.activeCompData.id + "-" + moment().format("X")+ this.chosenCustomerInfo.id + ".png";

            this.deviatingAdvice.uploading = true;
            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .putString(this.deviatingAdvice.clientSignature.split(",")[1], "base64" );

            uploadTask.on(
              "state_changed",
              taskSnapshot => {},
              error => {
                console.log(error);
                reject();
              },
              () => {
                console.log("The upload is compleet");
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(url => {
                    db.collection("deviatingAdvices")
                    .add({
                      companyId: this.activeCompData.id,
                      salonhub_ID: this.chosenCustomerInfo.id,
                      deviatings: this.deviatingAdvice.deviatings,
                      advice: this.deviatingAdvice.advice,
                      clientChoice: this.deviatingAdvice.clientChoice,
                      timestamp: this.deviatingAdvice.timestamp,
                      clientName: this.deviatingAdvice.clientName,
                      clientSignature: url,
                      active: true
                    })
                    .then((docRef)=>{
                      this.chosenCustomerInfo.deviatingAdvices.unshift({
                        companyId: this.activeCompData.id,
                        salonhub_ID: this.chosenCustomerInfo.id,
                        deviatings: _.cloneDeep(this.deviatingAdvice.deviatings),
                        advice: _.cloneDeep(this.deviatingAdvice.advice),
                        clientChoice: _.cloneDeep(this.deviatingAdvice.clientChoice),
                        timestamp: _.cloneDeep(this.deviatingAdvice.timestamp),
                        clientName: _.cloneDeep(this.deviatingAdvice.clientName),
                        clientSignature: url,
                        id: docRef.id
                      })
                    })
                    .then(()=>{
                      this.closeDeviatingAdviceDialog();
                    })
                    .catch(err => {
                      this.deviatingAdvice.feedback = "Fout bij opslaan. Probeer het opnieuw."
                      console.error("Error adding document to deviatingAdvices", err);
                    });


                  })
                  .catch(error => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              }
            );

          }
          else{
             this.deviatingAdvice.feedback = "Naam en handtekening zijn verplicht."
          }
        }
        else{
          let missingItems = new Array();

          this.deviatingAdvice.deviatings.forEach(deviating=>{
            if(deviating == "differentLength" && !length){missingItems.push('Lengte')}
            if(deviating == "differentColor" && !color){missingItems.push('Kleur')}
            if(deviating == "differentBrand" && !brand){missingItems.push('Merk')}
            if(deviating == "differentNumber" && !number){missingItems.push('Aantal')}
          })
          let items = missingItems.join(", ");
          let lastCommaIndex = items.lastIndexOf(",");
          let itemsCorrect = lastCommaIndex > 0 ? items.slice(0, lastCommaIndex) + " en " + items.slice(lastCommaIndex + 1, items.length) : items;

          let itemsSentence = missingItems.length == 1 ? "Dit is" : "Deze zijn";
          this.deviatingAdvice.feedback = `Het afwijkend advies gaat over <strong>${itemsCorrect}</strong>. ${itemsSentence} niet volledig ingevuld bij <strong>Geadviseerd</strong> en <strong>Gekozen door klant</strong>.`;
        }
      }
      else{
        this.deviatingAdvice.feedback = "Er zijn geen afwijkende wensen van de klant geselecteerd."
      }
    },

    removeClientDeviatingAdvice(id){
      db.collection("deviatingAdvices").doc(id).set({
        active: false,
        removeDate: new Date(),
        removeUser: this.userFirstName + " " + this.userLastName,
      },{merge: true})
      .then(()=>{
        let index = _.findIndex(this.chosenCustomerInfo.deviatingAdvices, { 'id': id }); 
        if(index >= 0){
          this.chosenCustomerInfo.deviatingAdvices.splice(index, 1)
        }
        this.closeDeviatingAdviceDialog()
      })
      .catch(error=>{
        console.error("Fout bij verwijderen van afwijkend advies: ", error)
      })
    },

    newClientDeviatingAdvice(){
      this.deviatingAdvice.type = "new";
      this.deviatingAdvice.timestamp = moment().format("YYYY-MM-DDTHH:mm");
      this.deviatingAdvice.deviatings = new Array();
      this.deviatingAdvice.dialog = true;
    },

    newClientMembership(){
      bus.$emit("openMembershipDialog", this.selectedClientId);
    },

  
    showSnackbar(value){
      if(value == 'succes'){
        this.snackbar.active = true;
        this.snackbar.timeout = 8000;
        this.snackbar.color = "rgba(0, 0, 0, 0.7)";
        this.snackbar.icon = "hourglass_empty";
        this.snackbar.text = "De foto's zijn succesvol verstuurd. Een klein ogenblik geduld... ";
        setTimeout(() => {
          this.snackbar.active = true;
          this.snackbar.timeout = 3000;
          this.snackbar.color = "rgba(1, 230, 110, 0.7)";
          this.snackbar.icon = "thumb_up";
          this.snackbar.text = "De fotos zijn klaar voor gebruik.";
          this.selectClientRecipe(this.selectedClientId, 1);
        }, 9000);
      }
    },

    comparePhotos(){
      bus.$emit("compareClientPhotos", this.chosenCustomerInfo.id);
    },

    calculateWindowHeigth(){
      this.windowDossierHeight = (window.innerHeight - 270) + 'px'
      this.windowDossierClientHeight = (window.innerHeight - 150) + 'px'
    },

    addNewClientQueue(){
      this.newQueueDialog = true
      bus.$emit("setQueueBranchAndData", this.chosenCustomerInfo);
    },

    createClientPhoto(){
      bus.$emit("getClientPhotoData", this.chosenCustomerInfo.id);
    },

    tabChanged (selectedTab) {
      if(selectedTab.tab.name == 'Recepten'){
        this.selectedTab = "recepten"
      } else {
        this.selectedTab = "klanten"
      }  
    },

    goToSalonhubClients(){
      router.replace("/online-afspraken");
    },

    editSurveyData(id){
      bus.$emit("getJourneyData", id);
    },

    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve();
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
        }
      })
      .then(()=>{
        
        if(this.caller || this.id){
          this.companies.forEach(company => {
            if (company.id == this.activeComp) {
              this.activeCompData = company;
            }
          });

          // Als er gebeld wordt
          if (this.caller) {
            // Verwijder onnodige tekens en pak de laatste 9 cijfers
            let docID = this.activeComp + this.caller.replace(/\D+/g, "").replace(/^[01]/, "").slice(-9);

            db.collection("VOIPclients")
              .doc(docID)
              .get()
              .then(doc => {
                if (!doc.exists) {
                  this.clientNotFound()
                } 
                else {
                  this.selectClientRecipe(doc.data().salonhubID, 1);
                }
              })
              .catch(err => {
                console.error("Error getting document", err);
              });
              this.countQueueClientsPrep()
          } 
          // 
          else{
            new Promise((resolve, reject)=>{
              let counter = 0
              this.companies.forEach(data => {
                if (data.id == this.activeComp) {
                  this.activeCompData = data;
                }
                counter++
                if(counter == this.companies.length){
                  resolve()
                }
              });
            })
            .then(()=>{
              this.selectClientRecipe(Number(this.id), 1);
            })
            .then(()=>{
              this.countQueueClientsPrep()
            })
          }
        }
        
        else {
          this.loadBranches();
        }
      })
    },
    
    loadBranches() {
      this.dataloaded = false;
      window.localStorage.setItem('selectedCompany', this.activeComp)
      this.branches = [];
      this.selectedBranch = [];

      this.companies.forEach(data => {
        if (data.id == this.activeComp) {
          this.activeCompData = data;
        }
      });

      // Load branches
      this.branches = [];
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          let branchCounter = 0;
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            });
          }).then(() => {
            this.selectedBranch = this.branches[0].id;
            this.loadselectedBranchData();
          });
        } else {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = true;
        }
      } else {
        db.collection("branches")
          .where("compId", "==", this.activeComp)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
              this.selectedBranches.push(doc.id);
              // this.selectedBranchesSalonhub.push(doc.data().branchNameSalonhub);
            });
          })
          .then(() => {
            this.selectedBranch = this.branches[0].id;
            this.loadselectedBranchData();
          });
      }
    },

    ConvertEmployeeRecipe(employeeId) {
      // Salonhub werkt bij Recepten anders ID moet matchen met Parent ID
      // console.log("Start zoeken employeeId", employeeId);
      for (let i = this.resourcesbooking.employees.length - 1; i >= 0; i--) {
        if (this.resourcesbooking.employees[i].parent == employeeId) {
          this.chosenEmployeeId = this.resourcesbooking.employees[i].name;
        }
      }
    },

    clientNotFound(){
      this.callerNotFound = true
      this.wolfload = false;
      this.loadingError = null;
      this.dataloaded = true;
      this.noData = false;
      this.userDataLoaded = true;
      this.callersname = null
    },

    loadSurveyData(survey) {
      this.surveyQuestions = survey.surveyQuestions;
    },

    closeSurveyData(survey) {
      this.selectedCustomerSurveys.forEach(surveyItem => {
        surveyItem.expanded = false;
      });
      survey.expanded = true;
    },

    ConvertEmployeeAllclients(employeeId) {
      // console.log("Start zoeken employeeId", employeeId);
      for (let i = this.salonhub.data.employees.length - 1; i >= 0; i--) {
        if (this.salonhub.data.employees[i].id == employeeId) {
          this.chosenEmployeeId = this.salonhub.data.employees[i].name;
        }
      }
    },

    loadselectedBranchData() {
      this.dataloaded = false;
      this.selectedBranchData = {};
      if (this.selectedBranch) {
        db.collection("branches")
          .doc(this.selectedBranch)
          .get()
          .then(doc => {
            this.selectedBranchData = doc.data();
          })
          .then(() => {
            this.noData = false;
            this.userDataLoaded = true;
            this.loadDossierData(this.chosenDateCalendar);
          });
      } else {
        this.userDataLoaded = true;
        this.dataloaded = true;
        this.noData = true;
      }
    },

    loadDossierData(dateselect) {

      this.resourcebooking = {};
      this.recipes = [];
      this.dataloaded = false;
      const todayUnix = moment(dateselect).locale("nl").unix();
      this.timeinfo = moment(dateselect).locale("nl").format("dddd D MMMM");
      let todayDDMMYYYY = moment(dateselect).locale("nl").format("DDMMYYYY");

      if (this.activeCompData.apiItems.salonhub == true) {
        //Haalt alle Salonhub instellingen binnen
      axios
        .get(
          "https://public.salonhub.nl/current/" +
            this.activeCompData.salonhubApiSettings.customer +
            "/" +
            this.activeCompData.salonhubApiSettings.username +
            "/" +
            this.activeCompData.salonhubApiSettings.md5 +
            "/salon/" +
            this.selectedBranchData.branchNameSalonhub +
            "/retrieveSettings"
        )
        .then(response => {
          this.salonhub = null;
          this.salonhub = response.data;
        })

        .then(() => {
          //Haalt alle klanten van de gekozen datum binnen
          axios
            .get(
              "https://public.salonhub.nl/current/" +
                this.activeCompData.salonhubApiSettings.customer +
                "/" +
                this.activeCompData.salonhubApiSettings.username +
                "/" +
                this.activeCompData.salonhubApiSettings.md5 +
                "/salon/" +
                this.selectedBranchData.branchNameSalonhub +
                "/loadAppointment?date=" +
                todayDDMMYYYY
            )
            //axios.get(this.selectedTreatment.field_pintrest_rss, config)
            .then(response => {
              // console.log("recepten: ", response.data);
              //Filter de juiste dag
              this.resourcesbooking = response.data[todayDDMMYYYY];
            })
            .then(() => {
              this.resourcesbooking.appointments = _.sortBy(
                this.resourcesbooking.appointments,
                ["startHour", "startMinute"]
              );

              this.resourcesbooking.appointments = _.uniqBy(
                this.resourcesbooking.appointments,
                "customer"
              );
            })
            
            .then(() => {
              //Firebase haalt alle bijhorende klanten binnen voor een Thumbnail
              this.clientThumbs = [];
              for (
                let index = 0;
                index < this.resourcesbooking.appointments.length;
                index++
              ) {
                db.collection("clientphotos")
                  .where("company", "==", this.activeComp)
                  .where(
                    "salonhub_ID",
                    "==",
                    Number(this.resourcesbooking.appointments[index].customer)
                  )

                  .orderBy("datePhoto", "desc")
                  .limit(1)
                  .get()
                  .then(snapshot => {
                    snapshot.forEach(doc => {
                      if (doc.exists) {
                        // console.log("Document data:", doc.data());
                        let clienthumbs = {};
                        clienthumbs.front_thumb = doc.data().photoCollection.front_thumb;
                        clienthumbs.salonhub_id = Number(
                          this.resourcesbooking.appointments[index].customer
                        );
                        this.clientThumbs.push(clienthumbs);
                      } else {
                        // doc.data() will be undefined in this case
                        // console.log("No such document!");
                      }
                    });
                  })
                  .catch(error => {
                    console.error("Error getting document:", error);
                  });
              }
            })
            .then(()=>{
              // console.log("Volgende stap")
              if(this.resourcesbooking.appointments.length > 0){
                let appointmentCounter = 0
                new Promise((resolve, reject)=>{
                  this.resourcesbooking.appointments.forEach(appointment=>{
                  // console.log("Appointment bekijken: ", appointment.customerEmail )
                  appointment.latestJourneyScore = null
                  let customerSurveys = []

                  if(this.validateEmail(appointment.customerEmail)){
                    let pillarrrCustomerId = slugify(appointment.customerEmail, {
                      replacement: "",
                      remove: /[!@#$%^&*()"';:.,]/g,
                      lower: true
                    })
                    
                    // console.log("pillarrrCustomerId: ", pillarrrCustomerId)
                    // console.log("activeComp: ", this.activeComp)
                    
                    db.collection("surveys")
                      .where("clientId","==", pillarrrCustomerId)
                      .where("compId","==", this.activeComp)
                      .orderBy("dateSend", "desc")
                      
                      .limit(1)
                      .get()
                      .then(snap => {
                        snap.forEach(doc => {
                          let survey = doc.data();
                          survey.id = doc.id;
                          survey.expanded = false
                          customerSurveys.push(survey);
                        });
                      })
                      .then(()=>{
                        let latestSurveyScores = []
                        if(customerSurveys.length > 0){
                          customerSurveys[0].surveyQuestions.map(survey=>{
                            if(survey.rating){
                              latestSurveyScores.push(survey.rating)
                            }
                          })
                          if(latestSurveyScores.length > 0){
                            appointment.latestJourneyScore = Math.min.apply(null, latestSurveyScores)
                          }
                        }
                      })
                      .then(()=>{
                        appointmentCounter++
                        if(appointmentCounter == this.resourcesbooking.appointments.length){
                          resolve()
                        }
                      })
                      .catch(error=>{
                        console.error("Er ging iets fout bij het binnenhalen van laatste score van client, ", error)  
                        appointmentCounter++
                        if(appointmentCounter == this.resourcesbooking.appointments.length){
                          resolve()
                        }
                      })
                    } else{
                      appointmentCounter++
                      if(appointmentCounter == this.resourcesbooking.appointments.length){
                        resolve()
                      }
                    }
                  }) 
                })
                .then(()=>{
                  // console.log("Appointment Promise Resolve")
                  this.getRecipies(todayUnix)
                })
                 
              } else {
                // console.log("Geen recepten")
                this.getRecipies(todayUnix)
              }
              
            })
            
            .catch(error => {
              this.dataloaded = true;
              this.loadingError =
                "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
              //Catch Error Salonhub Clients
              console.error("Fout  bij binnenhalen Salonhubdata: ", error);
            });
          })
          .catch(error => {
            this.dataloaded = true;
            this.loadingError =
              "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
            // Catch Error Salonhub Settings
            console.error("Fout  bij binnenhalen Salonhubdata: ", error);
          });
      
    
      } else{
        this.dataloaded = true;
        this.loadingError = "Er is nog geen API-koppeling met Salonhub.";
      }

    },

    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    getClientNotes(klantId){
      this.clientNotes = []
      db.collection("clientNotes")
        .where("salonhub_ID", "==", Number(klantId))
        .where("compId" , "==", this.activeComp)
        .where("active" , "==", true)
        .orderBy("dateAdded", 'desc')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let note = doc.data();
            note.id = doc.id;
            this.clientNotes.push(note)
          });
        }).then(()=>{
          // console.log("Client Notes zijn binnen")
        })
        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error getting Client Notes: ", error);
        });
    },

    getClientSocial(klantId){
      this.piggyPointsLoading = true;
      this.clientSocial = {}
      this.clientSocialDialog = {
        id: null,
        show: false,
        feedback: null,
        busy: false,
        instagram: null,
        piggy: {
          email:null,
        },
        instagramOriginal:null, 
        piggyOriginal: null,
        success: null
      }
      db.collection("clientSocial")
        .where("salonhub_ID", "==", Number(klantId))
        .where("compId" , "==", this.activeComp)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let social = doc.data();
            social.id = doc.id;
            this.clientSocial = social
          });
        }).then(()=>{
          if(this.clientSocial.id){
            this.clientSocialDialog.id = this.clientSocial.id
          }
          if(this.clientSocial.piggy){
              this.clientSocialDialog.piggy.email = this.clientSocial.piggy.email
              this.clientSocialDialog.piggyOriginal = _.cloneDeep(this.clientSocialDialog.piggy.email)
          } 
          if(this.clientSocial.instagram){
            this.clientSocialDialog.instagram = this.clientSocial.instagram
            this.clientSocialDialog.instagramOriginal = _.cloneDeep(this.clientSocialDialog.instagram)
          }
          // console.log("Client Notes zijn binnen")
        })
        .then(()=>{
          // Get current Piggy Points 
          if(this.clientSocial.piggy && this.clientSocial.piggy.email){

            let headers = {
              "piggy-api-key": this.activeCompData.piggy.api
            };

            axios({
              method: "get",
              url: "https://api.piggy.nl/api/public/customers/credits?email="+this.clientSocial.piggy.email,
              headers: headers,
              validateStatus: function(status) {
                return status == 200 || status == 400; // default
              }
            })
            .then(response=> {
              if (response.status == 400) {
                this.clientPiggyPoints = 'notfound';
              } 

              if (response.status == 200) {
                this.clientPiggyPoints = response.data.credits;
              }
              this.piggyPointsLoading = false;
            })
          }
          else{
            this.clientPiggyPoints = null;
            this.piggyPointsLoading = false;
          }

        })
        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error getting Client Social: ", error);
        });
    },

    getClientAttention(klantId){
      this.clientAttentions = []
      db.collection("clientAttentions")
        .where("salonhub_ID", "==", Number(klantId))
        .where("compId" , "==", this.activeComp)
        .where("active" , "==", true)
        .orderBy("type")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let attention = doc.data();
            attention.id = doc.id;
            this.clientAttentions.push(attention)
          });
        }).then(()=>{
          // console.log("Client Attentions zijn binnen")
        })
        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error getting Client Attentions: ", error);
        });
    },

    removeClientAttention(id, index){
      db.collection("clientAttentions").doc(id).update({
        active: false,
        deactivationDate: new Date(),
        deactivationUser: this.userFirstName + " " + this.userLastName,
      })
      .then(() => {
        db.collection("log")
          .add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            action: "Aandachtspunt verwijderd van klant",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            extra:
              "<b>Salonhub Id:</b> " +
              this.clientAttentions[index].salonhub_ID +
              "<br>" +
              "<b>Type:</b> " +
              this.clientAttentions[index].type +
              "<br>" +
              "<b>Aandachtspunt:</b> " +
              this.clientAttentions[index].text  +
              "<br>" +
              "<b>Verwijderd door:</b> " +
              this.userFirstName + " " + this.userLastName
          })
          .catch(error => {
            console.error("Error logging new branch: ", error);
          });
      })
      .then(() => {
        this.clientAttentions.splice(index, 1)
      })
    },

    removeClientNote(id, index){
      db.collection("clientNotes").doc(id).update({
        active: false,
        deactivationDate: new Date(),
        deactivationUser: this.userFirstName + " " + this.userLastName,
      })
      .then(() => {
        db.collection("log")
          .add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            action: "Notitie verwijderd van klant",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            extra:
              "<b>Salonhub Id:</b> " +
              this.clientNotes[index].salonhub_ID +
              "<br>" +
              "<b>Aandachtspunt:</b> " +
              this.clientNotes[index].text  +
              "<br>" +
              "<b>Verwijderd door:</b> " +
              this.userFirstName + " " + this.userLastName
          })
          .catch(error => {
            console.error("Error logging new branch: ", error);
          });
      })
      .then(() => {
        this.clientNotes.splice(index, 1)
      })
    },

    addClientSocial(){
      this.clientSocialDialog.feedback = null
      this.clientSocialDialog.busy = true
      let salonhubId = Number(this.chosenCustomerInfo.customer)

      if(this.clientSocialDialog.piggy.email && this.clientSocialDialog.instagram){

        this.clientSocialDialog.instagram = String(this.clientSocialDialog.instagram).toLowerCase()
        this.clientSocialDialog.piggy.email = String(this.clientSocialDialog.piggy.email).toLowerCase()
        this.clientSocialDialog.instagramOriginal = _.cloneDeep(this.clientSocialDialog.instagram)
        this.clientSocialDialog.piggyOriginal = _.cloneDeep(this.clientSocialDialog.piggy.email)

        const toast = this.$swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 8000
        });
        
        if(this.clientSocialDialog.id){
          db.collection("clientSocial").doc(this.clientSocialDialog.id)
          .update({
            piggy: this.clientSocialDialog.piggy,
            instagram: String(this.clientSocialDialog.instagram).toLowerCase(),
            lastUpdated: new Date()
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                software: String(platform.os),
                browser: platform.name + ' ' + platform.version, 
                pillarrrVersion: this.$store.state.version,
                action: "Social koppeling van klant aangepast",
                extra:
                  "<b>Salonhub Id:</b> " +
                  this.chosenCustomerInfo.customer +
                  "<br>" +
                  "<b>Piggy E-mail:</b> " +
                  this.clientSocialDialog.piggy.email +
                  "<br>" +
                  "<b>Instagram Username:</b> " +
                  this.clientSocialDialog.instagram
              })
              .then(()=>{
                  this.clientSocial.piggy = this.clientSocialDialog.piggy
                  this.clientSocial.instagram = this.clientSocialDialog.instagram
                  this.clientSocial.piggyOriginal = _.cloneDeep(this.clientSocialDialog.piggy.email)
                  this.clientSocial.instagramOriginal  = _.cloneDeep(this.clientSocialDialog.instagram)
                  this.clientSocialDialog.show = false
                  this.clientSocialDialog.busy = false

                  toast({
                    type: "success",
                    title: `De wijzigingen zijn succesvol opgeslagen.`
                  });
              
                })
              .catch(error => {
                console.error("Error logging new branch: ", error);
                this.clientSocialDialog.feedback = "Er is iets misgegaan bij het opslaan. Probeer opnieuw."
                this.clientSocialDialog.busy = false
              });
          })
        } 
        else {
          let body = {
            credits: 10, // How many piggy point? 
            purchase_amount: 0, 
            shop_id: this.activeCompData.piggy.shop_id,  //shop id from Companies document
            email: this.clientSocialDialog.piggy.email // email piggy user
          };

          let headers = {
            "piggy-api-key": this.activeCompData.piggy.api //api from Companies document
          };

          axios({
            method: "post",
            url: "https://api.piggy.nl/api/public/credit-receptions",
            data: body,
            headers: headers
          })
            .then(response => {
              console.log(`Piggy => Fully authorised: ${response.status}`);
              if(response.status == 200) {
                db.collection("clientSocial")
                  .add({
                    salonhub_ID: salonhubId,
                    piggy: this.clientSocialDialog.piggy,
                    instagram: this.clientSocialDialog.instagram,
                    compId: this.activeComp,
                    lastUpdated: new Date()
                  })
                  .then(() => {
                    db.collection("log")
                      .add({
                        time: new Date(),
                        logType: "info",
                        user: this.userFirstName + " " + this.userLastName,
                        userType: this.userRole,
                        company: this.userCompany,
                        actionType: "User Action",
                        software: String(platform.os),
                        browser: platform.name + ' ' + platform.version, 
                        pillarrrVersion: this.$store.state.version,
                        action: "Social koppeling van klant toegevoegd",
                        extra:
                          "<b>Salonhub Id:</b> " +
                          this.chosenCustomerInfo.customer +
                          "<br>" +
                          "<b>Piggy E-mail:</b> " +
                          this.clientSocialDialog.piggy.email +
                          "<br>" +
                          "<b>Instagram Username:</b> " +
                          this.clientSocialDialog.instagram
                      })
                      .then(()=>{
                        this.clientSocial.piggy = this.clientSocialDialog.piggy
                        this.clientSocial.instagram = this.clientSocialDialog.instagram
                        this.clientSocial.piggyOriginal = _.cloneDeep(this.clientSocialDialog.piggy.email)
                        this.clientSocial.instagramOriginal  = _.cloneDeep(this.clientSocialDialog.instagram)
                        this.clientSocialDialog.show = false
                        this.clientSocialDialog.busy = false
                        toast({
                          type: "success",
                          title: `Het Piggy-account is gekoppeld. Er zijn 10 punten aan het account toegevoegd.`
                        });
                      })
                      .catch(error => {
                        console.error("Error logging new branch: ", error);
                        this.clientSocialDialog.feedback = "Er is iets misgegaan bij het opslaan. Probeer opnieuw."
                        this.clientSocialDialog.busy = false
                      });
                  })
              }
            })
            .catch(error=> {
              console.log(error);
              if (error.response) {
                // console.log(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
              }
              this.clientSocialDialog.busy = false
              this.clientSocialDialog.feedback = "Piggy account kan niet gevonden worden. Probeer een ander e-mailadres."
            });
        } 
      }
      else{
        this.clientSocial.feedback = "Vul alle velden in om de koppeling te maken."
      }
    },

    addClientAttention(){
      this.clientAttentionDialog.feedback = null
      this.clientAttentionDialog.busy = true
      let salonhubId = Number(this.chosenCustomerInfo.customer)
      db.collection("clientAttentions")
        .add({
          salonhub_ID: salonhubId,
          type: this.clientAttentionDialog.type,
          text: this.clientAttentionDialog.text,
          compId: this.activeComp,
          active: true,
          dateAdded: new Date()
        })
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Nieuw aandachtspunt van klant",
              extra:
                "<b>Salonhub Id:</b> " +
                this.chosenCustomerInfo.customer +
                "<br>" +
                "<b>Type:</b> " +
                this.clientAttentionDialog.type +
                "<br>" +
                "<b>Aandachtspunt:</b> " +
                this.clientAttentionDialog.text
            })
            .catch(error => {
              console.error("Error logging new branch: ", error);
              this.clientAttentionDialog.feedback = "Er is iets misgegaan bij het opslaan. Probeer opnieuw."
            });
        })
        .then(() => {
          this.clientAttentionDialog.show = false
          this.clientAttentionDialog.type = "do"
          this.clientAttentionDialog.text = "",
          this.clientAttentionDialog.busy = false
          this.getClientAttention(salonhubId)
        })
    },

    addClientNote(){
      this.clientNoteDialog.feedback = null
      this.clientNoteDialog.busy = true
      let salonhubId = Number(this.chosenCustomerInfo.customer)
      db.collection("clientNotes")
        .add({
          salonhub_ID: salonhubId,
          text: this.clientNoteDialog.text,
          compId: this.activeComp,
          active: true,
          dateAdded: new Date()
        })
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Nieuwe notitie van klant",
              extra:
                "<b>Salonhub Id:</b> " +
                this.chosenCustomerInfo.customer +
                "<br>" +
                "<b>Notitie:</b> " +
                this.clientNoteDialog.text
            })
            .catch(error => {
              console.error("Error logging new branch: ", error);
              this.clientNoteDialog.feedback = "Er is iets misgegaan bij het opslaan. Probeer opnieuw."
            });
        })
        .then(() => {
          this.clientNoteDialog.show = false
          this.clientNoteDialog.text = "",
          this.clientNoteDialog.busy = false
          this.getClientNotes(salonhubId)
        })
    },

    
    getRecipies(todayUnix){
      //Recepten binnen laden
      axios
        .get(
          "https://public.salonhub.nl/current/" +
            this.activeCompData.salonhubApiSettings.customer +
            "/" +
            this.activeCompData.salonhubApiSettings.username +
            "/" +
            this.activeCompData.salonhubApiSettings.md5 +
            "/salon/" +
            this.selectedBranchData.branchNameSalonhub +
            "/getAppointmentsWithRecipe?day=" +
            todayUnix
        )

        //axios.get(this.selectedTreatment.field_pintrest_rss, config)
        .then(response => {
          this.recipes = response.data;

          this.salonhubsettings = true;
          this.dataloaded = true;
          this.loadingError = null;
        })
        .catch(error => {
          this.dataloaded = true;
          this.loadingError =
            "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
          console.error(error);
        });
    },

    selectClientRecipe(klantId, clientwithoutrecipe) {     
      this.wolfload = true;
      this.chosenCustomerRecipe = clientwithoutrecipe;
      let newestRecipe = {};
      let withoutNewest = {};
      // console.log("Ik ben customer, ", klantId);

      if (klantId == 0) {
        this.noclientdialog = true;
        this.wolfload = false;
      } else {
        this.lastclientPhotos = {};

        this.getClientAttention(klantId)
        this.getClientNotes(klantId)
        this.getClientSocial(klantId)

        db.collection("clientphotos")
        .where("company", "==", this.activeComp)
        .where("salonhub_ID", "==", Number(klantId))
        .orderBy("datePhoto", "desc")
        .limit(1)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let clientphoto = doc.data();
            clientphoto.id = doc.id;
            this.lastclientPhotos = clientphoto;
          });
        })
        .then(() => {
          // console.log("Documentloaded successfully!");
        })

        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error document: ", error);
        });

        axios
          .get(
            "https://public.salonhub.nl/current/" +
              this.activeCompData.salonhubApiSettings.customer +
              "/" +
              this.activeCompData.salonhubApiSettings.username +
              "/" +
              this.activeCompData.salonhubApiSettings.md5 +
              "/salon/" +
              this.activeCompData.salonhubApiSettings.salons[0].salonhubid +
              "/getCustomer?id=" +
              klantId
          )
          //axios.get(this.selectedTreatment.field_pintrest_rss, config)
          .then(response => {
            // console.log(response.data);

            //Huidige informatie van de klant.
            this.chosenCustomerInfo = response.data;
            this.namecustomer = response.data.firstname + ' ' + response.data.lastname;

            if (
              Object.keys(response.data.coloring).length == 0 &&
              clientwithoutrecipe == 0
            ) {
              this.norecipedialog = true;
            } else {
              newestRecipe = response.data;
              withoutNewest = response.data;

              this.chosenCustomerrecipeNewest = _.maxBy(
                newestRecipe.coloring,
                "date"
              );
              _.remove(
                withoutNewest.coloring,
                _.maxBy(newestRecipe.coloring, "date")
              );

              this.chosenCustomerrecipe = withoutNewest;

              // console.log("Checker undefined", typeof this.chosenCustomerrecipeNewest === "undefined");

              if (
                typeof this.chosenCustomerrecipeNewest === "undefined" ||
                this.chosenCustomerrecipeNewest.employeeName == null
              ) {
                // console.log("Employee is NULL of bestaat niet, medewerker ontbreekt");
                this.employeephoto = "";
              } else {
                const employeephotoID = this.chosenCustomerrecipeNewest
                  .employee;
                // console.log("Dit is photoID ", employeephotoID);

                this.employeephoto =
                  `https://assets.salonhub.nl/a/${
                    this.activeCompData.salonhubApiSettings.customer
                  }/employees/` +
                  employeephotoID +
                  ".jpg";
              }

              if (this.caller) {
                this.notesActive = true;
              }

              this.callersname = this.chosenCustomerInfo.firstname + " " + this.chosenCustomerInfo.lastname;
            }
          })
          
          .then(()=>{
            // Load Customer Journey Data
            this.loadJourneyDataCustomer();
            this.loadCustomerMemberships();
            this.chosenCustomerInfo.deviatingAdvices = new Array();
            this.chosenCustomerInfo.medicalIntakes = new Array();
            this.chosenCustomerInfo.complains = new Array();
            db.collection("intakes")
              .where("companyId", "==", this.activeComp)
              .where("salonhubId", "==", Number(klantId))
              .orderBy("dateAdded", "desc")
              .get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                  let item = doc.data();
                  item.id = doc.id;
                  this.chosenCustomerInfo.medicalIntakes.push(item);
                });
              })

              db.collection("complains")
              .where("companyId", "==", this.activeComp)
              .where("salonhubId", "==", Number(klantId))
              .orderBy("date", "desc")
              .get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                  let item = doc.data();
                  item.id = doc.id;
                  this.chosenCustomerInfo.complains.push(item);
                });
              })

            db.collection("deviatingAdvices")
              .where("companyId", "==", this.activeComp)
              .where("salonhub_ID", "==", klantId)
              .where("active", "==", true)
              .orderBy("timestamp", "desc")
              .get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                  let item = doc.data();
                  item.id = doc.id;
                  this.chosenCustomerInfo.deviatingAdvices.push(item);
                });
              })
              .then(() => {
                this.wolfload = false;
                this.loadingError = null;
                this.dataloaded = true;
                this.noData = false;
                this.userDataLoaded = true;
              })
              .catch(error => {
                this.dataloaded = true;
                this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
                console.error("Error document: ", error);
              });
          })
          .catch(error => {
            this.dataloaded = true;
            this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
            console.error(error);
          });
      }
    },

    loadCustomerMemberships(){
      console.log("loadCustomerMemberships")
      this.chosenCustomerInfo.memberships = new Array();
      db.collection("memberships")
        .where("companyId", "==", this.activeComp)
        .where("salonhubId", "==", +this.chosenCustomerInfo.id)
        .orderBy("dateAdded", "desc")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let membership = doc.data();
            membership.dateAddedFormatted = moment(doc.data().dateAdded.seconds, "X").format("D MMM YYYY H:mm")
            membership.id = doc.id;
            this.chosenCustomerInfo.memberships.push(membership);
            
          });
        })
        .then(()=>{
          this.membershipChanges++ 
        })
        .catch(error => {
          this.dataloaded = true;
          this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
          console.error("Error document: ", error);
        });
    },

    loadJourneyDataCustomer(){
      this.selectedCustomerSurveys = []
      if(this.chosenCustomerInfo.email){
        let pillarrrCustomer = slugify(this.chosenCustomerInfo.email, {
          replacement: "",
          remove: /[!@#$%^&*()"';:.,]/g,
          lower: true
        }); 

        db.collection("clients")
        .doc(pillarrrCustomer)
        .get()
        .then(doc => {
          if (!doc.exists) {
            // console.log("No such document!");
          } else {
            // console.log("Client bestaat", );
            if(doc.data().companies[this.activeComp].active){
              db.collection("surveys")
              .where("clientId","==", pillarrrCustomer)
              .where("compId","==", this.activeComp)
              .orderBy("dateSend" ,"desc")
              .get()
              .then(snap => {
                snap.forEach(doc => {
                  let survey = doc.data();
                  survey.id = doc.id;
                  survey.expanded = false
                  this.selectedCustomerSurveys.push(survey);
                });
              })
              .then(()=>{
                // Kijk wat de laagste score was de laatste keer.
                if(this.selectedCustomerSurveys.length > 0){
                  this.calculateLowestScore()
                }
              })
              .then(() =>{
                if(this.branches.length == 0){
                  db.collection("branches")
                  .where("compId", "==", this.activeComp)
                  .get()
                  .then(snap => {
                    snap.forEach(doc => {
                      let branchCollection = doc.data();
                      branchCollection.id = doc.id;
                      this.branches.push(branchCollection);
                    });
                  })
                }
              })
              .catch(err => {
                console.error("Error getting surveys from selected client", err);
              });

            } else {
              // console.log("Client is geen klant van deze salon", );
            }
          }
        })
        .catch(err => {
          console.error("Error getting document", err);
        });
      } else{
        // console.log("Client heeft geen email!");
      }
      
    },

    calculateLowestScore(){
      let latestSurveyScores = []
      
      this.selectedCustomerSurveys[0].surveyQuestions.map(survey=>{
        if(survey.rating){
          latestSurveyScores.push(survey.rating)
        } 
      })
      if(latestSurveyScores.length >0){
        this.latestSurveyScoresLowest = Math.min.apply(null, latestSurveyScores)
      } else{
        this.latestSurveyScoresLowest = null
      }
      
    },

    countQueueClientsPrep(){
      if(this.userRole == "employee" || this.userRole == "manager") {
        this.selectedBranches = this.userBranches
        this.countQueueClients()
      } else {
        db.collection("branches")
          .where("compId", "==", this.activeComp)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.selectedBranches.push(doc.id);
            });
          })
          .then(()=>{
            this.countQueueClients()
          })
      }
    },

    countQueueClients(){
      let today = new Date()
        if (this.selectedBranches.length > 0) {
          let branchCounter = 0;
          this.clientQueue = []
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("clientQueue")
                .where("queueEndDate",">", today)
                .where("branch", "==", branch)
                .where("deleted.deleted","==", false)
                .where("scheduled","==", false)
                .get()
                .then(snap => {
                  snap.forEach(doc => {
                    let client = doc.data();
                    this.clientQueue.push(client);
                  });
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            })
          })
        } else {
          // console.log("Geen userBranches")
        } 
    },
  },

  computed: {
    showFullScreen(){
      let browserWidth = window.innerWidth;
      if(browserWidth < 450){
        return true;
      }
      else{
        return false;
      }
    },

    dossierPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'dossier') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'dossier'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    clientSocialPiggy(){
      let socialPiggy = {
        icon: "close",
        color: "#C62828"
      }
      if(this.clientSocialDialog.piggy){
        if(this.clientSocialDialog.piggy.email){
          socialPiggy.icon = "done"
          socialPiggy.color = "#69F0AE"  
        }
      }
      return socialPiggy
    },

    clientSocialInstagram(){
      let socialInstagram= {
        icon: "close",
        color: "#C62828"
      }
      if(this.clientSocialDialog.instagram){
        socialInstagram.icon = "done"
        socialInstagram.color = "#69F0AE"
      }
      return socialInstagram
    },

    
    recipesFiltered(){
      let recipes = []
      if(this.recipes.results){
        this.recipes.results.forEach(recipe=>{
          recipe.thumbUrl = null
          recipe.employeeName = null
          recipe.latestJourneyScore = null

          // Format startMinute corrigeren
          if(recipe.startMinute == 0){
            recipe.startMinute = '00'
          }
          // Filter Client Thumb Picture
          this.clientThumbs.forEach(photoClient=>{
            if(recipe.customerId == photoClient.salonhub_id){
              recipe.thumbUrl = photoClient.front_thumb
            }                           
          })
          // Filter Employee Name
          this.resourcesbooking.employees.forEach(employee=>{
            if(recipe.employeeId == employee.parent){
              recipe.employeeName = employee.name
            }                           
          })
          // Filter Emotion Collect Scoree
          this.resourcesbooking.appointments.forEach(appointment=>{
            if(String(recipe.customerId) == appointment.customer){
              recipe.latestJourneyScore = appointment.latestJourneyScore
            }                           
          })

          recipes.push(recipe)
        })
      }
      

      return recipes
    },

    appointmentsFiltered(){
      let appointments = []
      if(this.resourcesbooking.appointments){
        this.resourcesbooking.appointments.forEach(appointment=>{
          appointment.thumbUrl = null
          appointment.employeeName = null
  

          // Format startMinute corrigeren
          if(appointment.startMinute == 0){
            appointment.startMinute = '00'
          }
          // Filter Client Thumb Picture
          this.clientThumbs.forEach(photoClient=>{
            if(appointment.customer == String(photoClient.salonhub_id)){
              appointment.thumbUrl = photoClient.front_thumb
            }                           
          })
          // Filter Employee Name
          this.resourcesbooking.employees.forEach(employeeInfo=>{
            if(appointment.employee == employeeInfo.id){
              appointment.employeeName = employeeInfo.name
            }                           
          })
          appointments.push(appointment)
        })
      }
      return appointments
    },

    clientAttentionIcon(){
      if(this.clientAttentionDialog.type == 'do'){
        return "add_circle"
      } else {
        return "remove_circle"
      }
    },

    companyDossierPhotos() {
      if (_.includes(this.$store.state.companyPackages, "dossierphotos")) {
        return true;
      } else {
        return false;
      }
    },

    userPermissions() {
      return this.$store.state.userPermissions;
    },

    demoMode(){
      return this.$store.state.demoMode;
    },
    
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filterGridClass(){
      if(this.userCompanies.length > 1 && !this.demoMode){
        return "md3"
      } else {
        return "md4"
      }
    },
    socialChanged() {
      if (_.isEqual(this.clientSocialDialog.instagram , this.clientSocialDialog.instagramOriginal) == false || _.isEqual(this.clientSocialDialog.piggy.email , this.clientSocialDialog.piggyOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    socialDisable(){
      if(this.clientSocialDialog.busy || !this.socialChanged){
        return true
      } else {
        return false
      }
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    clientColumn(){
      if(this.caller || this.id){
        return "xs12"
      } else {
        return "xs12 sm8"
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
  },
  watch: {
    zoekSalonhubClient() {
      const url = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/searchCustomer?salon=*&query=${encodeURI(this.zoekSalonhubClient)}`
      const urlCustomerId = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(this.zoekSalonhubClient)}`
    
      return new Promise(resolve => {
        let counter = 0;
        if (!this.zoekSalonhubClient || (this.zoekSalonhubClient && this.zoekSalonhubClient.length < 3)) {
          this.searchResultsSalonhub = [];
          return resolve([])
        } 
        else {
          this.searchResultsSalonhub = [];
          this.loaderSearch = true;
          fetch(url)
          .then(response => response.json())
          .then(data => {
            counter++
            if(counter == 2){
              resolve()
            }
            this.searchResultsSalonhub = data.slice(0,15)
          })
          fetch(urlCustomerId)
          .then(response => response.json())
          .then(data => {
            if(data){
              this.searchResultsSalonhub.unshift(data);
            }
            counter++
            if(counter == 2){
              resolve()
            }
          })
        } 
      })
      .then(()=>{
        this.loaderSearch = false
      })
    },
  }
};

</script>

<style>

.client-header-wrapper {
  position: relative;
  min-height: 60px;
  padding: 10px 0 0 0;
  margin: 12px 0 0 0;
}
.client-header-wrapper .client-camer-button {
  position: absolute;
  right: 0;
  top: 0;
}

 .client-header-button{
  display: block; 
  float: right;
  position: relative;
  height: 56px;
  width: 56px;
  margin: 5px 15px;
}

.login-wrapper-test {
  width: 300px;
  padding: 20px;
  border-radius: 3px;
  margin: 50px auto;
  background-color: #ffffff;
}

.fullscreenRadius {
  border-radius: 0px!important;
}

a,
div,
span,
input,
textarea,
select:focus {
  outline: none;
}

.clear::after {
  display: block;
  content: "";
  clear: both;
}

p.no-clients {
  margin: 0;
  padding: 20px 10px;
  text-align: center;
}

#header {
  position: relative;
  width: 100%;
  height: 73px;
}
.dossier-header {
  background-color: #fff !important;
  border-bottom: 1px solid #e8e9ee;
  height: 73px;
  position: absolute;
  width: calc(100% - 80px);
  top: 0;
  right: 0;
}

.dossier-header .v-stepper__header,
.dossier-header .v-stepper {
  box-shadow: none !important;
}

/* .container {
  padding: 10px !important;
} */

#content-wrapper.small {
  width: calc(100% - 270px);
  margin-left: 300px;
  background-color: #f6f7fb;
  position: relative;
}

#content-wrapper.big {
  width: calc(100% - 80px);
  top: 73px;
  height: 100%;
  left: 80px;
  background-color: #f6f7fb;
  position: absolute;
}

.dossier-date-select {
  float: right;
  padding: 15px;
}

/* .client-select-box {
  margin-top: 15px 0 0 0;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
} */

.client-select-box .v-list {
  padding: 0 !important;
}

.client-select-box .v-card {
  box-shadow: none !important;
}

.menu-logo {
  width: 80px;
  height: 75px;
  margin: 0 auto;
  /* background: url("https://www.hairbeautycompany.nl/themes/custom/greenpower/img/hbc-logo-menu.svg") */
    /* no-repeat center center; */
  background-size: auto 60px;
}

.client-select-box ul.tabs-component-tabs {
  display: inline-block;
  list-style: none;
  height: 31px;
  padding: 0 0 0 10px;
}

.client-select-box ul.tabs-component-tabs:after {
  display: block;
  content: "";
  clear: both;
}

.client-select-box ul.tabs-component-tabs li {
  float: left;
  display: block;
  margin: 0 10px 0 0;
}

.client-select-box ul.tabs-component-tabs li a {
  padding: 10px 10px 6px 10px;
  background-color: var(--v-menuhover-base);
  color: var(--v-text-base);
  font-size: 14px;
  text-decoration: none;
  display: block;
  border: 1px solid var(--v-menuborder-base);
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

.client-select-box ul.tabs-component-tabs li.is-active a {
  background-color: var(--v-menu-base);
  color: var(--v-text-base);
  border-bottom: 1px solid var(--v-menu-base);
}

.wolfload {
  width: 80px;
  height: 80px;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateX(-50%);
  transform: translateY(-50%);
}

.client-info-wrapper {
  width: 100%;
  padding: 0 0 0 15px;
}

h2.client-title {
  padding: 15px 0 0 0;
  font-size: 18px;
  font-weight: 600;
  display: inline-block;
}

.client-basic-info {
  padding: 10px 0;
}

.client-basic-info .v-card,
.client-color-info .v-card {
  border: 1px solid #e8e9ee;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

.client-basic-info .v-card,
.client-table-wrapper .v-card {
  border: 1px solid #e8e9ee;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
}

.client-color-info h2,
.client-table-wrapper h2,
.photobox h2 {
  font-size: 20px;
  padding: 5px 2px;
}

.v-icon.pillar-grey {
  color: #bfc5d2 !important;
}

.client-email .v-icon,
.client-birtday .v-icon,
.client-visits .v-icon,
.client-last-visit .v-icon,
.client-notes .v-icon,
.client-notes .v-icon,
.recipe-info .v-icon,
.recipe-date .v-icon,
.recipe-time .v-icon,
.recipe-person .v-icon {
  float: left;
}
.client-email p,
.client-birtday p,
.client-visits p,
.client-last-visit p,
.client-notes p {
  color: var(--v-text-base);
  float: left;
  font-size: 13px;
  padding: 3px 5px;
  margin: 0 0 10px 0;
  max-width: 550px;
}

.recipe-info p,
.recipe-date p,
.recipe-time p,
.recipe-person p {
  font-family: "Sofia Pro", sans-serif;
  color: var(--v-text-base);
  float: left;
  font-size: 13px;
  padding: 3px 5px;
  margin: 0 0 10px 0;
  max-width: 350px;
}

.recipe-employee-photo {
  height: 100px;
  width: 100px;
  border: 4px solid var(--v-menuborder-base);
  border-radius: 100px;
  overflow: hidden;
  background-color: #F5F5F5;
  margin: 5px auto 0 auto;
}

.recipe-employee-photo img {
  width: 100%;
}

.recipe-employee-photo-wrapper {
  float: right;
  width: 120px;
}

.recipe-employee-photo-wrapper p {
  text-align: center;
  color: var(--v-text-base);;
  font-size: 13px;
  padding: 5px 0;
}

/* NO CONNECTION POPUP */

.connection-popup-wrapper {
  padding: 16px;
}

h2.connection-popup-header {
  font-family: "TT Norms";
  font-size: 38px;
  font-weight: 700;
  text-align: center;
}

.connection {
  margin: 15px auto;
  width: 100px;
  height: 100px;
}

.lost-connection-text {
  color: var(--v-text-base);
  text-align: center;
  font-size: 14px;
  line-height: 18px;
}

.salon-info-wrapper {
  position: absolute;
  margin: 22px 0 0 333px;
  font-size: 16px;
  color: #251433;
}

.salon-avatar {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  background-color: rgba(95, 29, 154, 0.2);
  font-size: 12px;
  color: #610d9c;
  text-align: center;
  padding: 7px 0;
  margin: 0 5px 0 0;
}

h2.currentdate {
  padding: 10px 10px 12px 10px;
  font-size: 22px;
  font-weight: 600;
  color: var(--v-text-base);
  text-transform: capitalize;
}

.select-client-type img {
  width: 100%;
  height: auto;
}

#content-wrapper .v-stepper,
#content-wrapper .v-stepper__header {
  background: none !important;
  box-shadow: none;
}

.relative {
  position: relative;
}
.treatment-wrapper {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: relative;
}

.treatment-wrapper .v-stepper__content,
.treatment-wrapper .container {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
}
.treatments-list-wrapper {
  border-right: 1px solid var(--v-menuborder-base);;
}

.treatments-list-wrapper .v-list {
  padding: 0 !important;
}

.treatments-list-wrapper .v-list__tile {
  padding: 0 5px !important;
}
.treatments-list-wrapper {
  max-height: 100%;
  width: 100%;
  position: absolute;
  overflow-y: scroll;
}

.treatments-list-wrapper .v-list__tile__title {
  font-size: 14px;
}

.selected-treatment-wrapper {
  padding: 15px;
  position: relative;
  min-height: 700px;
}

h2.selected-treatment-title {
  padding: 10px 0;
  font-size: 22px;
  color: var(--v-text-base);;
}

.add-extra-button {
  position: absolute;
  right: 10px;
  top: 10px;
}

.selected-treatment-intro {
  padding: 10px;
  margin: 20px 0;
}

.selected-treatment-intro .v-carousel {
  box-shadow: none;
}

.treatment-desc .v-icon {
  float: left;
}
.treatment-desc p {
  color: var(--v-text-base);;
  float: left;
  font-size: 13px;
  padding: 3px 5px;
  margin: 0 0 10px 0;
  max-width: 240px;
}
.recommended-wrapper h3,
.chosen-wrapper h3 {
  font-size: 15px;
  color: var(--v-text-base);;
  padding: 10px 0;
  font-weight: 600;
}

.wolfload {
  z-index: 90;
}
/* .wolfload .blackbox {
  position: relative;
  display: block !important;
  background-color: rgba(0, 0, 0, 0.45);
  padding: 16px;
  height: 80px;
  width: 80px;
  border-radius: 5px;
} */
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.fromprice {
  text-decoration-line: line-through;
}

.selected-treatment-price {
  padding: 10px;
  margin: 10px 10px 10px 0;
}

.selected-treatment-actions {
  padding: 10px;
  margin: 10px 0 10px 10px;
}

.selected-treatment-price p {
  color: var(--v-text-base);;
  margin: 5px 0;
  font-size: 15px;
}

.selected-treatment-price p.price-discount {
  color: var(--v-text-base);;
  margin: 5px 0;
  font-size: 17px;
}

.selected-treatment-price p.price-total {
  color: #00e676;
  margin: 5px 0;
  font-size: 17px;
  font-weight: 700;
}

.popup-icon .v-icon {
  margin: 0 auto;
  font-size: 60px;
  width: 60px;
  display: block;
}

.popup-title {
  margin: 10px 0;
}
div.v-stepper__wrapper {
  height: 100%;
}

.container.dossier {
  padding: 0 !important;
}

.client-notes p {
  color: transparent !important;
  text-shadow: 0 0 8px rgba(139, 147, 169, 0.5);
}

.client-notes,
.client-notes:hover {
  cursor: pointer;
}

.client-notes p.active {
  color: var(--v-text-base) !important;
  text-shadow: none;
}

.no-caller-data {
  width: 350px;
  margin: 250px auto;
}

.no-caller-data p {
  text-align: center;
}

.no-caller-data .v-card{
  border-radius: 10px;
  -webkit-box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}

.dossier-client-lowest-score{
  width: 67px;
  height: 67px;
  float: right;
  display: block;
  background-size: 85px!important; 
}

.dossier-client-lowest-score.rating-number-5{
  background: url("../assets/icons/rating/rating-icon-super.png") no-repeat center center;
}

.dossier-client-lowest-score.rating-number-4{
  background: url("../assets/icons/rating/rating-icon-goed.png") no-repeat center center;
}
.dossier-client-lowest-score.rating-number-3{
  background: url("../assets/icons/rating/rating-icon-voldoende.png") no-repeat center center;
}

.dossier-client-lowest-score.rating-number-2{
  background: url("../assets/icons/rating/rating-icon-onvoldoende.png") no-repeat center center;
}

.dossier-client-lowest-score.rating-number-1{
  background: url("../assets/icons/rating/rating-icon-slecht.png") no-repeat center center;
}

.dossier-table{
  background: #ffffff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  color: #25142A;
}

.client-datatable.header.dossier {
  padding: 15px 0 10px 0;
  background-color: var(--v-menu-base);
  border-bottom: 1px solid var(--v-menuborder-base);
}

.client-datatable.dossier.expanded-row {
  background-color: var(--v-background-base);
  padding: 8px 0;
  min-height: 40px;
  border-bottom: 1px solid var(--v-menuborder-base);
}

.list-extra-info{
  color: var(--v-text-base)!important;
}

.attention-wrapper{
  padding: 0 10px 0 0;
}

.attention-icon,
.attention-remove{
  width: 40px;
  float: left;
}

.attention-text{
  width: calc(100% - 80px);
  float: left;
}

.note-wrapper{
  padding: 0px;
  margin: 0 0 5px 0;
}

.note-date{
  width: 50px;
  float: left;
}

.note-date-cal-wrap{
  width: 44px;
  height: 44px;
  padding: 4px;
  border-radius: 8px;
}

.note-date-cal-day{
  width: 36px;
  height: 21px;
  text-align: center;
  line-height: 23px;
  font-size: 20px;
  color: var(--v-menu-base);
}

.note-date-cal-month{
  width: 36px;
  padding: 0 0 0;
  font-size: 10px;
  color: var(--v-menu-base);
  text-align: center;
  text-transform: uppercase;
}

.note-text{
  width: calc(100% - 90px);
  float: left;
  padding: 2px 4px;
}

.note-remove{
  width: 40px;
  float: left;
}

.ofText{
  text-align: center;
  padding: 10px 0 0 0;
  display: block;
  font-size: 18px;
  font-weight: 600;
  width: 100%
}

@media only screen and (max-width: 1024px) {
  .ofText{
    text-align: center;
    padding: 5px 0;
    display: block;
    font-size: 18px;
    font-weight: 600;
    width: 100%
  }
}

.blackbox-loader{
  z-index: 999;
}
</style>
